(function () {
const I18N = {
      de: {
        eyebrow: "AAC Modellcode-Checker",
        headline: "Prüfe, ob dein Fahrzeug kompatibel ist.",
        intro: "Gib deinen Modellcode ein. Wir zeigen dir, ob Adaptive Assistance Control zu deinem Toyota passt.",
        ssot: "Aktueller Kompatibilitätsstand für Toyota Fahrzeuge.",
        dbUpdated: "Datenbank zuletzt aktualisiert: 28.06.2026.",
        stepCode: "Modellcode",
        stepDate: "Datum",
        stepDisplay: "Display",
        stepResult: "Resultat",
        completedCodeLabel: "Modellcode",
        completedDateLabel: "Datum",
        completedDisplayLabel: "Kombiinstrument",
        codeLabel: "Gib den Modellcode deines Fahrzeugs ein:",
        codePlaceholder: "z. B. MXPJ10L-BHXNBW",
        checkBtn: "Überprüfen",
        whereLink: "Wo finde ich den Modellcode meines Fahrzeugs?",
        scanUploadBtn: "Foto hochladen",
        scanUploadBtnShort: "Foto",
        scanTip: "Lade ein scharfes, gut belichtetes Foto deines Typenschilds hoch.",
        scanCameraBtn: "Kamera nutzen",
        scanCameraBtnShort: "Kamera",
        scanChoiceCamera: "Foto aufnehmen",
        scanChoiceGallery: "Aus Galerie wählen",
        scanLoading: "Typenschild wird gelesen …",
        scanNoCode: "Der Modellcode konnte nicht erkannt werden. Bitte ein schärferes Foto hochladen oder den Code manuell eingeben.",
        scanNotHorizontal: "Das Foto wirkt gedreht. Bitte lade ein waagerechtes Foto hoch — Typenschild lesbar von links nach rechts, wie auf dem Beispielfoto.",
        scanReupload: "Foto erneut",
        scanError: "Der Upload konnte nicht verarbeitet werden. Bitte erneut versuchen oder den Code manuell eingeben.",
        detectedTitle: "Erkannte Fahrzeugdetails",
        dateTitle: "Prüfe die Fahrzeuginformationen und fülle das Modelljahr deines Fahrzeugs ein",
        continueBtn: "Weiter",
        displayTitle: "Welches Kombiinstrument ist in deinem Fahrzeug verbaut?",
        displayHint: "Wähle das Kombiinstrument in deinem Fahrzeug.",
        displayHelpLink: "Welches Kombiinstrument habe ich verbaut?",
        resultTitle: "Ergebnis",
        resetBtn: "Neu prüfen",
        modelCodeModalTitle: "Wo finde ich den Modellcode?",
        modelCodeModalText: "Der Modellcode steht auf dem Typenschild am Fahrzeug. Dieses befindet sich meistens an der A-Säule im Türfalz. Dort kann der Modellcode abgelesen werden.",
        displayModalTitle: "Welches Kombiinstrument habe ich verbaut?",
        displayModalText: "Die Bildschirmgrösse des Kombiinstruments ist relevant. Es gibt 12.3 Zoll Displays sowie kleinere Varianten, zum Beispiel 7 Zoll oder 4.2 Zoll Displays. Vergleiche dein Kombiinstrument mit den Beispielen unten.",
        displayModalExample12: "12.3 Zoll Display",
        displayModalExample12Sub: "Breites, volldigitales Kombiinstrument",
        displayModalExample7: "7 Zoll Display",
        displayModalExample7Sub: "Kleineres Display mit analogen Anzeigen",
        displayModalExample42: "4.2 Zoll Display",
        displayModalExample42Sub: "Kleines zentrales Display",
        empty: "Bitte gib einen Modellcode ein.",
        invalid: "Der eingegebene Code sieht nicht wie ein Toyota Modellcode aus. Prüfe Bindestrich, Zeichen und Länge.",
        notFound: "Dieser Modellcode konnte nicht gefunden werden.",
        notFoundTitle: "Nicht gefunden",
        notFoundIntro: "Dieser Modellcode ist nicht in unserer Liste. Tippfehler? Dann nochmals eingeben. Sonst kannst du dich eintragen — wir prüfen den Code oder benachrichtigen dich, wenn AAC für dieses Modell verfügbar ist.",
        notFoundRetry: "Code nochmals eingeben",
        notFoundNotify: "Eintragen und benachrichtigen lassen",
        notifyTitle: "Wir prüfen deinen Code",
        notifyIntro: "Hinterlasse deine E-Mail. Der Modellcode ist bereits erfasst. Du kannst ihn noch anpassen oder weitere Codes ergänzen.",
        notifyEmail: "E-Mail-Adresse",
        notifyEmailPlaceholder: "du@email.com",
        notifyLang: "Sprache der Nachricht",
        notifyLangDe: "Deutsch",
        notifyLangEn: "English",
        notifyCodesLabel: "Modellcode",
        notifyAddCode: "Weiteren Code hinzufügen",
        notifyEditCode: "Code bearbeiten",
        notifyRemoveCode: "Code entfernen",
        notifySubmit: "Absenden",
        notifySuccessTitle: "Anfrage gesendet",
        notifySuccessText: "Danke. Wir prüfen den Code und melden uns, wenn AAC für dein Modell verfügbar ist.",
        notifyAgain: "Weiteren Code prüfen",
        notifyEmailInvalid: "Bitte eine gültige E-Mail-Adresse eingeben.",
        notifyCodeInvalid: "Bitte einen gültigen Modellcode eingeben.",
        formatOk: "Format erkannt. Suche passenden Eintrag …",
        found: "Modellcode gefunden. Prüfe die Fahrzeuginformationen und fülle das Modelljahr deines Fahrzeugs ein.",
        foundNoFurther: "Modellcode gefunden.",
        dateMissing: "Bitte Monat und Jahr auswählen.",
        olderThanData: "Das Fahrzeugdatum liegt vor dem unterstützten Produktionszeitraum für diesen Modellcode.",
        displayMismatch: "Dieses Kombiinstrument passt leider nicht zur AAC Kompatibilität dieses Modellcodes.",
        supportedFrom: "Kompatibel ab",
        suggestions: "Ähnliche Codes:",
        noValue: "Keine Angabe",
        supportedBadge: "{count} unterstützte Modellcodes",
        compatibleTitle: "Dein Auto ist kompatibel",
        compatibleText: "Das AAC Modul ist mit deinem Fahrzeug kompatibel",
        unknownTitle: "UNBEKANNT",
        unknownText: "Die Verkabelung vom AAC Modul ist grundsätzlich kompatibel mit deinem Fahrzeug, jedoch ist die Software unbekannt oder nicht getestet",
        notCompatibleTitle: "NICHT KOMPATIBEL",
        notCompatibleText: "Das AAC Modul ist leider nicht mit deinem Fahrzeug kompatibel",
        buyBtn: "AAC Modul kaufen",
        orderNow: "Jetzt bestellen",
        orderHint: "Direkt zur sicheren Kasse",
        checkoutError: "Es gab ein Problem beim Bestellen. Bitte versuche es erneut.",
        suggestCheckBtn: "Entwicklung vorschlagen",
        suggestDevBtn: "Entwicklung vorschlagen",
        suggestionSaved: "Danke. Deine Fahrzeugkonfiguration wurde als Nachfrage gespeichert.",
        suggestionError: "Die Anfrage konnte nicht gespeichert werden. Bitte versuche es später nochmals.",
        details: {
          Full_Code: "Modellcode",
          Vehicle_Name: "Modellname",
          Base_Code: "Basiscode",
          Engine: "Motor",
          Transmission: "Getriebe",
          Edition: "Edition",
          Production: "Produktionsland",
          Body: "Karosserietyp",
          Steering: "Lenkung",
          Destination: "Region",
          Roof: "Dach",
          Trunk: "Heck/Tür"
        },
        months: ["Monat", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        yearPlaceholder: "Jahr",
        display12: "12.3 Zoll",
        display7: "7 Zoll",
        displayOther: "Anderes / weiss nicht",
        display12Sub: "Grosses digitales Kombiinstrument",
        display7Sub: "Kleineres Kombiinstrument",
        displayOtherSub: "Zum Beispiel 4.2 Zoll oder eine andere Variante",
        systemsTitle: "Steuerbare Systeme",
        systemsCount: "{count} Systeme",
        systemsIntro: "AAC kann diese Systeme steuern, sofern sie in deinem Fahrzeug verbaut sind.",
        systemsExtra: "Zusätzlich",
        systemsAutoLearn: "AutoLearn",
        systemsTipLabel: "Was ist das?",
        sys: {
          isa: { name: "Intelligent Speed Assist", short: "ISA", tip: "Warnt, wenn du schneller fährst als erlaubt." },
          rsa: { name: "Verkehrszeichenerkennung", short: "RSA", tip: "Road Sign Assist. Erkennt Verkehrszeichen und zeigt sie im Kombiinstrument." },
          pcs: { name: "Pre-Collision System", short: "PCS", tip: "Kollisionswarnung und Notbremsassistent, wenn ein Hindernis erkannt wird." },
          lda: { name: "Spurverlassenswarner", short: "LDA", tip: "Lane Departure Alert. Warnt, wenn du die Fahrspur verlässt." },
          bsm: { name: "Totwinkelmonitor", short: "BSM", tip: "Blind Spot Monitor. Warnt vor Fahrzeugen im toten Winkel." },
          rcta: { name: "Querverkehrswarner hinten", short: "RCTA", tip: "Rear Cross Traffic Alert. Warnt beim Rückwärtsfahren vor Querverkehr." },
          sea: { name: "Safe Exit Assist", short: "SEA", tip: "Warnt beim Aussteigen, wenn sich von hinten Verkehr nähert." },
          rest: { name: "Pausenerinnerung", short: "", tip: "Erinnert dich daran, eine Pause einzulegen." },
          ebs: { name: "Emergency Brake Signal", short: "EBS", tip: "Warnblinker bei starkem Bremsen." },
          pbrake: { name: "Warnung Feststellbremse", short: "", tip: "Verzögert die Warnung der mechanischen Handbremse während der Fahrt." },
          dms: { name: "Driver Monitor", short: "DMS", tip: "Überwacht Aufmerksamkeit und Müdigkeit." },
          dmsLearn: "Erscheint in der App, sobald das Modul den Driver Monitor im Fahrzeug erkannt hat. Bleibt bis zum Zurücksetzen gespeichert.",
          ics: { name: "Intelligent Clearance Sonar", short: "ICS", tip: "Warnt vor Hindernissen beim Rangieren." },
          pksb: { name: "Parking Support Brake", short: "PKSB", tip: "Kann beim Rangieren automatisch bremsen." },
          rcd: { name: "Rear Camera Detection", short: "RCD", tip: "Erkennt Objekte hinter dem Fahrzeug." },
          lca: { name: "Spurwechselassistent", short: "LCA", tip: "Lane Change Assist. Unterstützt beim Spurwechsel." },
          pda: { name: "Proaktiver Fahrassistent", short: "PDA", tip: "Proactive Driving Assist. Unterstützt vorausschauendes Fahren." },
          fcta: { name: "Querverkehrswarner vorne", short: "FCTA", tip: "Front Cross Traffic Alert. Warnt vor Querverkehr vorne." },
          warnings: { name: "Warnleuchten unterdrücken", short: "", tip: "Kann Warnleuchten, Töne und Hinweise beim Deaktivieren unterdrücken. Kein Assistenzsystem, eigene Schaltfläche in der App." },
          circuit: { name: "CIRCUIT-Mode-Anzeige", short: "", tip: "Eigene Anzeige im Kombiinstrument beim GR Yaris. Kein Assistenzsystem." }
        }
      },
      en: {
        eyebrow: "AAC Model Code Checker",
        headline: "See if your vehicle is compatible.",
        intro: "Enter your model code. We’ll show you whether Adaptive Assistance Control is supported on your Toyota.",
        ssot: "Current compatibility status for Toyota vehicles.",
        dbUpdated: "Database last updated: 28/06/2026.",
        stepCode: "Model code",
        stepDate: "Date",
        stepDisplay: "Display",
        stepResult: "Result",
        completedCodeLabel: "Model code",
        completedDateLabel: "Date",
        completedDisplayLabel: "Display",
        codeLabel: "Enter your vehicle’s model code:",
        codePlaceholder: "e.g. MXPJ10L-BHXNBW",
        checkBtn: "Check",
        whereLink: "Where can I find my vehicle’s model code?",
        scanUploadBtn: "Upload photo",
        scanUploadBtnShort: "Photo",
        scanTip: "Upload a sharp, well-lit photo of your type plate.",
        scanCameraBtn: "Use camera",
        scanCameraBtnShort: "Camera",
        scanChoiceCamera: "Take photo",
        scanChoiceGallery: "Choose from gallery",
        scanLoading: "Reading type plate …",
        scanNoCode: "The model code could not be recognized. Upload a sharper photo or enter the code manually.",
        scanNotHorizontal: "The photo appears rotated. Please upload a horizontal photo — type plate readable left to right, like the example photo.",
        scanReupload: "Upload again",
        scanError: "The upload could not be processed. Please try again or enter the code manually.",
        detectedTitle: "Detected vehicle details",
        dateTitle: "Check the vehicle information and enter your vehicle’s model year",
        continueBtn: "Continue",
        displayTitle: "Which instrument cluster is installed in your vehicle?",
        displayHint: "Select the instrument cluster in your vehicle.",
        displayHelpLink: "Which instrument cluster do I have?",
        resultTitle: "Result",
        resetBtn: "Check again",
        modelCodeModalTitle: "Where can I find the model code?",
        modelCodeModalText: "The model code is printed on the vehicle type plate. This is usually located on the A-pillar inside the door frame. Read the model code from that plate.",
        displayModalTitle: "Which instrument cluster do I have?",
        displayModalText: "The screen size of the instrument cluster is relevant. There are 12.3 inch displays as well as smaller versions, for example 7 inch or 4.2 inch displays. Compare your instrument cluster with the examples below.",
        displayModalExample12: "12.3 inch display",
        displayModalExample12Sub: "Wide, fully digital instrument cluster",
        displayModalExample7: "7 inch display",
        displayModalExample7Sub: "Smaller display with analogue gauges",
        displayModalExample42: "4.2 inch display",
        displayModalExample42Sub: "Small central display",
        empty: "Please enter a model code.",
        invalid: "The entered code does not look like a Toyota model code. Check the hyphen, characters and length.",
        notFound: "This model code could not be found.",
        notFoundTitle: "Not found",
        notFoundIntro: "This model code is not in our list. Typo? Enter it again. Otherwise you can leave your details — we’ll check the code or notify you when AAC is available for this model.",
        notFoundRetry: "Enter code again",
        notFoundNotify: "Sign up to be notified",
        notifyTitle: "We’ll check your code",
        notifyIntro: "Leave your email. The model code is already captured. You can still edit it or add more codes.",
        notifyEmail: "Email address",
        notifyEmailPlaceholder: "you@email.com",
        notifyLang: "Notification language",
        notifyLangDe: "Deutsch",
        notifyLangEn: "English",
        notifyCodesLabel: "Model code",
        notifyAddCode: "Add another code",
        notifyEditCode: "Edit code",
        notifyRemoveCode: "Remove code",
        notifySubmit: "Submit",
        notifySuccessTitle: "Request sent",
        notifySuccessText: "Thank you. We’ll check the code and get in touch when AAC is available for your model.",
        notifyAgain: "Check another code",
        notifyEmailInvalid: "Please enter a valid email address.",
        notifyCodeInvalid: "Please enter a valid model code.",
        formatOk: "Format detected. Searching for a matching entry …",
        found: "Model code found. Check the vehicle information and enter your vehicle’s model year.",
        foundNoFurther: "Model code found.",
        dateMissing: "Please select month and year.",
        olderThanData: "The vehicle date is earlier than the supported production period for this model code.",
        displayMismatch: "Unfortunately, this instrument cluster does not match the AAC compatibility for this model code.",
        supportedFrom: "Compatible from",
        suggestions: "Similar codes:",
        noValue: "No information",
        supportedBadge: "{count} supported model codes",
        compatibleTitle: "Your car is compatible",
        compatibleText: "The AAC Module is compatible with your vehicle",
        unknownTitle: "UNKNOWN",
        unknownText: "The AAC Module wiring is generally compatible with your vehicle, but the software is unknown or has not been tested",
        notCompatibleTitle: "NOT COMPATIBLE",
        notCompatibleText: "Unfortunately, the AAC Module is not compatible with your vehicle",
        buyBtn: "Buy AAC Module",
        orderNow: "Order now",
        orderHint: "Continue to secure checkout",
        checkoutError: "There was a problem placing your order. Please try again.",
        suggestCheckBtn: "Suggest development",
        suggestDevBtn: "Suggest development",
        suggestionSaved: "Thank you. Your vehicle configuration has been saved as a request.",
        suggestionError: "The request could not be saved. Please try again later.",
        details: {
          Full_Code: "Model code",
          Vehicle_Name: "Model name",
          Base_Code: "Base code",
          Engine: "Engine",
          Transmission: "Transmission",
          Edition: "Edition",
          Production: "Production country",
          Body: "Body type",
          Steering: "Steering",
          Destination: "Region",
          Roof: "Roof",
          Trunk: "Rear/door"
        },
        months: ["Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        yearPlaceholder: "Year",
        display12: "12.3 inch",
        display7: "7 inch",
        displayOther: "Other / not sure",
        display12Sub: "Large digital instrument cluster",
        display7Sub: "Smaller instrument cluster",
        displayOtherSub: "For example 4.2 inch or another version",
        systemsTitle: "Controllable systems",
        systemsCount: "{count} systems",
        systemsIntro: "AAC can control these systems if they are fitted in your vehicle.",
        systemsExtra: "Also included",
        systemsAutoLearn: "AutoLearn",
        systemsTipLabel: "What is this?",
        sys: {
          isa: { name: "Intelligent Speed Assist", short: "ISA", tip: "Warns when you drive faster than the limit." },
          rsa: { name: "Road Sign Assist", short: "RSA", tip: "Recognises traffic signs and shows them in the instrument cluster." },
          pcs: { name: "Pre-Collision System", short: "PCS", tip: "Collision warning and emergency braking when an obstacle is detected." },
          lda: { name: "Lane Departure Alert", short: "LDA", tip: "Warns if you leave the lane." },
          bsm: { name: "Blind Spot Monitor", short: "BSM", tip: "Warns of vehicles in the blind spot." },
          rcta: { name: "Rear Cross Traffic Alert", short: "RCTA", tip: "Warns of crossing traffic when reversing." },
          sea: { name: "Safe Exit Assist", short: "SEA", tip: "Warns when exiting if traffic is approaching from behind." },
          rest: { name: "Rest reminder", short: "", tip: "Reminds you to take a break." },
          ebs: { name: "Emergency Brake Signal", short: "EBS", tip: "Hazard lights during hard braking." },
          pbrake: { name: "Parking brake warning", short: "", tip: "Delays the mechanical parking-brake warning while driving." },
          dms: { name: "Driver Monitor", short: "DMS", tip: "Watches for attention and fatigue." },
          dmsLearn: "Appears in the app once the module has detected Driver Monitor in the vehicle. It stays stored until reset.",
          ics: { name: "Intelligent Clearance Sonar", short: "ICS", tip: "Warns of obstacles when manoeuvring." },
          pksb: { name: "Parking Support Brake", short: "PKSB", tip: "Can brake automatically when parking." },
          rcd: { name: "Rear Camera Detection", short: "RCD", tip: "Detects objects behind the vehicle." },
          lca: { name: "Lane Change Assist", short: "LCA", tip: "Assists when changing lanes." },
          pda: { name: "Proactive Driving Assist", short: "PDA", tip: "Supports anticipatory driving." },
          fcta: { name: "Front Cross Traffic Alert", short: "FCTA", tip: "Warns of crossing traffic in front." },
          warnings: { name: "Suppress warning lights", short: "", tip: "Can suppress warning lights, sounds and prompts when systems are turned off. Not an assistance system — a separate control in the app." },
          circuit: { name: "CIRCUIT mode display", short: "", tip: "A dedicated display in the GR Yaris instrument cluster. Not an assistance system." }
        }
      }
    };

    const AAC_ASSIST_IDS = ['isa','rsa','pcs','lda','bsm','rcta','sea','rest','ebs','pbrake','dms','ics','pksb','rcd','lca','pda','fcta'];
    const AAC_MODEL_SYSTEMS = {
      gr_yaris: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', ebs:'yes', pbrake:'yes', dms:'autolearn', ics:'yes', pksb:'yes', warnings:'yes', circuit:'yes' },
      yaris: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'autolearn', ics:'yes', pksb:'yes', warnings:'yes' },
      yaris_cross: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'autolearn', ics:'yes', pksb:'yes', warnings:'yes' },
      corolla: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', rest:'yes', dms:'autolearn', warnings:'yes' },
      corolla_cross: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'autolearn', pksb:'yes', rcd:'yes', warnings:'yes' },
      land_cruiser: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'yes', ics:'yes', rcd:'yes', pda:'yes', fcta:'yes', warnings:'yes' },
      hilux: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'yes', ics:'yes', rcd:'yes', pda:'yes', warnings:'yes' },
      c_hr: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'yes', ics:'yes', pksb:'yes', rcd:'yes', pda:'yes', fcta:'yes', warnings:'yes' },
      prius: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'yes', ics:'yes', pksb:'yes', rcd:'yes', pda:'yes', fcta:'yes', warnings:'yes' },
      bz4x: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', sea:'yes', rest:'yes', dms:'yes', ics:'yes', pksb:'yes', rcd:'yes', pda:'yes', fcta:'yes', warnings:'yes' },
      rav4: { isa:'yes', rsa:'yes', pcs:'yes', lda:'yes', bsm:'yes', rcta:'yes', ics:'yes', pksb:'yes', warnings:'yes' }
    };

  function createChecker(root, config) {
    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => Array.from(root.querySelectorAll(sel));
    const vehicleImages = Object.assign({}, config.vehicleImages || {});
    const vehicleImagesScript = root.querySelector('[data-checker-vehicle-images]');
    if (vehicleImagesScript) {
      try {
        JSON.parse(vehicleImagesScript.textContent || '[]').forEach((entry) => {
          if (entry?.key && entry?.src) vehicleImages[entry.key] = entry.src;
        });
      } catch (e) {}
    }
    let CHECKER_DATA = null;
    let recordsByCode = new Map();
    let SUPPORTED_CODE_COUNT = 0;
    let currentLang = (function (lang) {
      const code = String(lang || 'en').toLowerCase();
      return code === 'de' || code.startsWith('de-') ? 'de' : 'en';
    })(config.lang);
    let state = { matches: [], eligibleRows: [], selectedCode: null, selectedDate: null, selectedDisplay: null, lastResult: null, missedCode: null, notifySource: 'manual', notifyLang: null };
    const STEP_ORDER = ['code', 'date', 'display', 'result'];
    let checkoutBusy = false;
    const LIVE_CACHE_PREFIX = 'aacCheckerLive:v1:';
    const LIVE_CACHE_TTL_MS = 5 * 60 * 1000;
    const LIVE_FETCH_TIMEOUT_MS = 12000;
    let liveRefreshPromise = null;

    function t(key) {
      const parts = key.split('.');
      let value = I18N[currentLang];
      for (const part of parts) value = value?.[part];
      return value ?? key;
    }

    function normalizeCode(value) {
      return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/[‐‑‒–—−]/g, '-')
        .replace(/[^A-Z0-9-]/g, '')
        .replace(/--+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function yearFromValue(val) {
      if (val === undefined || val === null || val === '') return null;
      const s = String(val).trim();
      if (/^\d{4}-\d{2}/.test(s)) return s.slice(0, 7) + '-01';
      const mmyyyy = s.match(/^(\d{1,2})[./](\d{4})$/);
      if (mmyyyy) return `${mmyyyy[2]}-${mmyyyy[1].padStart(2, '0')}-01`;
      const n = Number(s);
      if (!Number.isNaN(n) && n > 30000) {
        const epoch = Date.UTC(1899, 11, 30);
        const d = new Date(epoch + n * 86400000);
        return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-01`;
      }
      return null;
    }

    function normalizeRecords(records) {
      return (records || []).map((record) => {
        const row = Object.assign({}, record);
        row._source = row._source != null ? Number(row._source) : 0;
        row._code = normalizeCode(row.Full_Code || row._code || '');
        if (!row._yearFrom) row._yearFrom = yearFromValue(row.Year_From);
        if (row.Cluster && !row.Display) row.Display = row.Cluster;
        return row;
      });
    }

    function indexRecords(records) {
      recordsByCode = new Map();
      records.forEach((record) => {
        const code = normalizeCode(record.Full_Code || record._code || '');
        if (!code) return;
        if (!recordsByCode.has(code)) recordsByCode.set(code, []);
        recordsByCode.get(code).push(record);
      });
      SUPPORTED_CODE_COUNT = new Set(
        records.filter((r) => String(r.Support || '').trim().toUpperCase() === 'YES')
          .map((r) => normalizeCode(r.Full_Code || r._code || ''))
      ).size;
    }

    function normalizeHeaderKey(key) {
      const raw = String(key || '').trim();
      const aliases = {
        Modellcode: 'Full_Code',
        'Model code': 'Full_Code',
        'Model Code': 'Full_Code',
        FULL_CODE: 'Full_Code',
        Fahrzeug: 'Vehicle_Name',
        Vehicle: 'Vehicle_Name',
        'Vehicle Name': 'Vehicle_Name',
        'Year From': 'Year_From',
        'Baujahr ab': 'Year_From'
      };
      return aliases[raw] || raw;
    }

    function normalizeSheetRecord(record) {
      const row = {};
      Object.keys(record || {}).forEach((key) => {
        row[normalizeHeaderKey(key)] = record[key];
      });
      return row;
    }

    function parseCsvRecords(text) {
      const lines = text.trim().split(/\r?\n/);
      const headers = lines.shift().split(',').map((h) => normalizeHeaderKey(h.trim().replace(/^"|"$/g, '')));
      return lines.filter(Boolean).map((line) => {
        const parts = line.split(',');
        const obj = {};
        headers.forEach((h, i) => { obj[h] = (parts[i] || '').replace(/^"|"$/g, ''); });
        return obj;
      });
    }

    function parseGviz(text) {
      const json = JSON.parse(text.replace(/^[^\{]*/, '').replace(/\);?\s*$/, ''));
      const cols = json.table.cols.map((c) => normalizeHeaderKey((c.label || c.id || '').trim()));
      return json.table.rows.map((row) => {
        const obj = {};
        row.c.forEach((cell, i) => {
          const key = cols[i];
          if (!key) return;
          obj[key] = cell && cell.v != null ? cell.v : '';
        });
        return obj;
      });
    }

    function sheetUrls(url) {
      const raw = String(url || '').trim();
      if (!raw) return [];
      const idMatch = raw.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
      const id = idMatch ? idMatch[1] : raw;
      const gidMatch = raw.match(/[?&#]gid=(\d+)/);
      const gid = gidMatch ? gidMatch[1] : '0';
      return [
        `https://docs.google.com/spreadsheets/d/${id}/gviz/tq?tqx=out:json&gid=${gid}`,
        `https://docs.google.com/spreadsheets/d/${id}/export?format=csv&gid=${gid}`
      ];
    }

    const LEGACY_LIVE_SHEET_KEYS = {
      prius_phev: 'prius',
      c_hr_phev: 'c_hr',
      corolla_hatchback: 'corolla',
      corolla_kombi: 'corolla',
      corolla_limousine: 'corolla',
      corolla_ts: 'corolla',
      rav4_plugin: 'rav4',
      rav4_plugin_2026: 'rav4_2026',
      bz4x_touring: 'bz4x'
    };

    function normalizeLiveSheetBlockKey(key) {
      const raw = String(key || '').trim();
      return LEGACY_LIVE_SHEET_KEYS[raw] || raw;
    }

    function nameHasYearSpan(name, fromYear, toYear) {
      return new RegExp(`${fromYear}\\s*[-–]\\s*${toYear}`).test(name);
    }

    function nameHasOpenYearFrom(name, year) {
      return new RegExp(`${year}\\s*[-–](?!\\s*\\d)`).test(name);
    }

    function isRav4NewGenName(name) {
      if (nameHasYearSpan(name, 2024, 2026)) return false;
      return nameHasOpenYearFrom(name, 2026);
    }

    function recordVehicleDetailKey(row) {
      const name = String(row?.Vehicle_Name || row?.Vehicle || '').toLowerCase();
      if (!name) return null;
      if (name.includes('corolla cross')) return 'corolla_cross';
      if (name.includes('corolla')) {
        const bodyCode = String(row?.Body || '').toUpperCase();
        const bodyText = String(row?.Body || '').toLowerCase();
        const tsName = /\bts\b/.test(name) || name.includes('touring');
        if (
          bodyCode === 'W' ||
          tsName ||
          bodyText.includes('kombi') ||
          bodyText.includes('station') ||
          bodyText.includes('wagon') ||
          bodyText.includes('touring')
        ) return 'corolla_ts';
        if (
          bodyCode === 'E' ||
          bodyText.includes('stufenheck') ||
          bodyText.includes('notchback') ||
          bodyText.includes('limousine') ||
          bodyText.includes('sedan')
        ) return 'corolla_limousine';
        return 'corolla';
      }
      if (name.includes('yaris cross')) return 'yaris_cross';
      if (name.includes('gr yaris')) return 'gr_yaris';
      if (name.includes('yaris')) return 'yaris';
      if (name.includes('land cruiser')) return 'land_cruiser';
      if (name.includes('prius')) return 'prius_phev';
      if (name.includes('bz4x') || name.includes('b z4x') || name.includes('bz 4x')) {
        const bodyCode = String(row?.Body || '').toUpperCase();
        const bodyText = String(row?.Body || '').toLowerCase();
        if (
          name.includes('touring') ||
          bodyCode === 'W' ||
          bodyText.includes('touring') ||
          bodyText.includes('kombi') ||
          bodyText.includes('station') ||
          bodyText.includes('wagon')
        ) return 'bz4x_touring';
        return 'bz4x';
      }
      if (name.includes('hilux')) return 'hilux';
      if (
        name.includes('c-hr+') ||
        name.includes('c-hr plus') ||
        name.includes('chr+') ||
        name.includes('c hr+') ||
        name.includes('chr plus')
      ) return 'c_hr_plus';
      if (name.includes('rav4')) {
        const plugin = name.includes('plug') || name.includes('phev');
        if (isRav4NewGenName(name)) return plugin ? 'rav4_plugin_2026' : 'rav4_2026';
        return plugin ? 'rav4_plugin' : 'rav4';
      }
      if (name.includes('c-hr') && name.includes('phev')) return 'c_hr_phev';
      if (name.includes('c-hr') || name.includes('chr')) return 'c_hr';
      return null;
    }

    function recordLiveSheetKey(row) {
      const detail = recordVehicleDetailKey(row);
      if (!detail) return null;
      if (detail === 'corolla' || detail === 'corolla_ts' || detail === 'corolla_hatchback' || detail === 'corolla_kombi' || detail === 'corolla_limousine') return 'corolla';
      if (detail === 'bz4x' || detail === 'bz4x_touring') return 'bz4x';
      if (detail === 'c_hr' || detail === 'c_hr_phev') return 'c_hr';
      if (detail === 'prius_phev') return 'prius';
      if (detail === 'rav4' || detail === 'rav4_plugin') return 'rav4';
      if (detail === 'rav4_2026' || detail === 'rav4_plugin_2026') return 'rav4_2026';
      return detail;
    }

    function getLiveSheetSources() {
      const sources = [];
      const script = root.querySelector('[data-checker-live-sheets]');
      if (script) {
        try {
          JSON.parse(script.textContent || '[]').forEach((entry) => {
            const model = normalizeLiveSheetBlockKey(entry?.model || entry?.vehicleKey || '');
            const scriptUrl = String(entry?.scriptUrl || entry?.script_url || '').trim();
            if (model && scriptUrl) sources.push({ model, scriptUrl });
          });
        } catch (e) {}
      }
      return sources;
    }

    function mergeOverlayRecords(baseRecords, overlayRecords, modelKey) {
      const sheetKey = normalizeLiveSheetBlockKey(modelKey);
      const overlay = normalizeRecords((overlayRecords || []).map(normalizeSheetRecord));
      if (!overlay.length) return baseRecords || [];
      const overlayCodes = new Set(
        overlay.map((row) => normalizeCode(row.Full_Code || row._code || '')).filter(Boolean)
      );
      const kept = (baseRecords || []).filter((row) => {
        const code = normalizeCode(row.Full_Code || row._code || '');
        if (overlayCodes.has(code)) return false;
        return recordLiveSheetKey(row) !== sheetKey;
      });
      return kept.concat(overlay);
    }

    function applyCheckerRecords(records, base, sourceFiles) {
      CHECKER_DATA = {
        generatedAt: new Date().toISOString(),
        recordCount: records.length,
        sourceFiles: sourceFiles != null ? sourceFiles : (base?.sourceFiles || []),
        records
      };
      indexRecords(CHECKER_DATA.records);
    }

    function readLivePayloadCache(url) {
      try {
        const raw = sessionStorage.getItem(LIVE_CACHE_PREFIX + url);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.at || !parsed?.data || Date.now() - parsed.at > LIVE_CACHE_TTL_MS) return null;
        return parsed.data;
      } catch (e) {
        return null;
      }
    }

    function writeLivePayloadCache(url, data) {
      try {
        sessionStorage.setItem(LIVE_CACHE_PREFIX + url, JSON.stringify({ at: Date.now(), data }));
      } catch (e) {}
    }

    async function fetchWithTimeout(url, timeoutMs) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeoutMs);
      try {
        return await fetch(url, { cache: 'no-store', signal: controller.signal });
      } finally {
        clearTimeout(timer);
      }
    }

    async function fetchLivePayloadFromEndpoint(url) {
      const raw = String(url || '').trim();
      if (!raw) return null;

      if (raw.includes('script.google.com')) {
        const cached = readLivePayloadCache(raw);
        if (cached) return cached;

        try {
          const res = await fetchWithTimeout(raw, LIVE_FETCH_TIMEOUT_MS);
          if (!res.ok) return null;
          const data = await res.json();
          const records = Array.isArray(data.records) ? data.records : (Array.isArray(data) ? data : []);
          if (!records.length) return null;
          const sourceFiles = Array.isArray(data.sourceFiles)
            ? data.sourceFiles
            : (data.legend ? [{ id: 0, legend: data.legend }] : []);
          const payload = {
            records: records.map(normalizeSheetRecord),
            sourceFiles
          };
          writeLivePayloadCache(raw, payload);
          return payload;
        } catch (e) {
          return null;
        }
      }

      const records = await fetchRecordsFromSheetUrl(raw);
      return records?.length ? { records, sourceFiles: [] } : null;
    }

    async function fetchRecordsFromSheetUrl(url) {
      const urls = sheetUrls(url);
      for (const fetchUrl of urls) {
        try {
          const res = await fetch(fetchUrl, { cache: 'no-store' });
          if (!res.ok) continue;
          const text = await res.text();
          if (text.includes('<!DOCTYPE html') || text.includes('accounts.google.com')) continue;
          const records = fetchUrl.includes('gviz/tq') ? parseGviz(text) : parseCsvRecords(text);
          if (records.length) return records.map(normalizeSheetRecord);
        } catch (e) {}
      }
      return null;
    }

    async function fetchRecordsFromEndpoint(url) {
      const payload = await fetchLivePayloadFromEndpoint(url);
      return payload?.records || null;
    }

    async function loadStaticBaseData() {
      const fallbackUrl = config.dataUrl;
      if (!fallbackUrl) return null;
      try {
        const res = await fetch(fallbackUrl);
        if (!res.ok) return null;
        return await res.json();
      } catch (e) {
        return null;
      }
    }

    function mergeLiveSourcePayload(mergedRecords, sourceFiles, source, payload) {
      if (!payload?.records?.length) return { mergedRecords, sourceFiles, mergedLive: false };

      let sourceIndex = null;
      const legend = payload.sourceFiles?.[0]?.legend;
      if (legend && Object.keys(legend).length) {
        sourceIndex = sourceFiles.length;
        sourceFiles.push({ id: sourceIndex, legend });
      }

      const taggedRecords = payload.records.map((record) => {
        const row = Object.assign({}, record);
        if (sourceIndex != null) row._source = sourceIndex;
        return row;
      });

      return {
        mergedRecords: mergeOverlayRecords(mergedRecords, taggedRecords, source.model),
        sourceFiles,
        mergedLive: true
      };
    }

    function refreshCheckerUiAfterLiveMerge() {
      const badge = $('[data-aac-supported-count]');
      if (badge) badge.textContent = t('supportedBadge').replace('{count}', SUPPORTED_CODE_COUNT);
      if (state.lastResult) {
        rerenderLastResult();
        return;
      }
      if (!state.selectedCode) return;
      const matches = recordsByCode.get(state.selectedCode) || [];
      if (!matches.length) return;
      state.matches = matches;
      if (state.selectedDate) {
        state.eligibleRows = matches.filter((row) => {
          const from = parseISODate(row._yearFrom);
          return !from || state.selectedDate >= from;
        });
      } else {
        state.eligibleRows = matches.slice();
      }
      if (!$('[data-panel="result"]').classList.contains('hidden')) return;
      renderDetails(state.eligibleRows.length ? state.eligibleRows : state.matches);
    }

    async function refreshLiveSheetOverlays(base) {
      const sources = getLiveSheetSources();
      if (!sources.length) return false;

      const results = await Promise.allSettled(
        sources.map(async (source) => ({
          source,
          payload: await fetchLivePayloadFromEndpoint(source.scriptUrl)
        }))
      );

      let mergedRecords = normalizeRecords(CHECKER_DATA?.records || base?.records || []);
      let sourceFiles = [...(CHECKER_DATA?.sourceFiles || base?.sourceFiles || [])];
      let mergedLive = false;

      results.forEach((result) => {
        if (result.status !== 'fulfilled') return;
        const merged = mergeLiveSourcePayload(
          mergedRecords,
          sourceFiles,
          result.value.source,
          result.value.payload
        );
        mergedRecords = merged.mergedRecords;
        sourceFiles = merged.sourceFiles;
        if (merged.mergedLive) mergedLive = true;
      });

      if (!mergedLive) return false;
      applyCheckerRecords(mergedRecords, base, sourceFiles);
      refreshCheckerUiAfterLiveMerge();
      return true;
    }

    async function bootstrapCheckerData() {
      const base = await loadStaticBaseData();
      const sheetUrl = config.sheetsUrl;

      if (sheetUrl) {
        const payload = await fetchLivePayloadFromEndpoint(sheetUrl);
        if (payload?.records?.length) {
          applyCheckerRecords(
            normalizeRecords(payload.records),
            base,
            payload.sourceFiles?.length ? payload.sourceFiles : base?.sourceFiles
          );
          return;
        }
      }

      const liveSources = getLiveSheetSources();
      if (base?.records?.length) {
        applyCheckerRecords(normalizeRecords(base.records), base, base.sourceFiles || []);
      } else if (!liveSources.length) {
        throw new Error('checker-data-unavailable');
      }

      if (!liveSources.length) return;

      liveRefreshPromise = refreshLiveSheetOverlays(base).catch(() => false);
      const refreshed = await Promise.race([
        liveRefreshPromise,
        new Promise((resolve) => { setTimeout(() => resolve(false), 350); })
      ]);
      if (!refreshed && !base?.records?.length) {
        const ok = await liveRefreshPromise;
        if (!ok) throw new Error('checker-data-unavailable');
      }
    }

    async function fetchCheckerData() {
      await bootstrapCheckerData();
    }

    function renderI18n() {
      root.setAttribute('lang', currentLang);
      $$('[data-i18n]').forEach((el) => { el.textContent = t(el.dataset.i18n); });
      $$('[data-i18n-placeholder]').forEach((el) => { el.placeholder = t(el.dataset.i18nPlaceholder); });
      const uploadBtn = $('[data-scan-upload]');
      const cameraBtn = $('[data-scan-camera]');
      if (uploadBtn) uploadBtn.setAttribute('aria-label', t('scanUploadBtn'));
      if (cameraBtn) cameraBtn.setAttribute('aria-label', t('scanCameraBtn'));
      const badge = $('[data-aac-supported-count]');
      if (badge) badge.textContent = t('supportedBadge').replace('{count}', SUPPORTED_CODE_COUNT);
      renderMonthYearOptions();
      if (state.matches.length && !$('[data-panel="result"]').classList.contains('hidden')) {
        renderDetails(state.eligibleRows.length ? state.eligibleRows : state.matches);
      }
      if (!$('[data-panel="result"]').classList.contains('hidden')) rerenderLastResult();
    }

    function validateModelCode(code) {
      const normalized = normalizeCode(code);
      if (!normalized) return { ok: false, message: t('empty') };
      if (!/^[A-Z0-9]{4,12}[LR]-[A-Z0-9]{4,12}$/.test(normalized)) return { ok: false, message: t('invalid') };
      const left = normalized.split('-')[0];
      if (!/\d/.test(left)) return { ok: false, message: t('invalid') };
      return { ok: true, code: normalized };
    }

    const CODE_PATTERN = /[A-Z0-9]{4,12}[LR]-[A-Z0-9]{4,12}/g;
    const CODE_LOOSE_PATTERN = /([A-Z0-9]{4,12}[LR])\s*[-–]?\s*([A-Z0-9]{4,12})/g;
    const MODEL_ANCHOR_PATTERNS = [
      /MODEL\s*[:\s]*([A-Z0-9]{4,12}[LR])[\s\-–]+([A-Z0-9]{4,12})/,
      /MODEL[^A-Z0-9\n]{0,16}([A-Z0-9]{4,12}[LR])[\s\-–]*([A-Z0-9]{4,12})/,
      /MODEL[^\n]{0,90}\n[^\n]{0,24}([A-Z0-9]{4,12}[LR])[\s\-–]*([A-Z0-9]{4,12})/,
      /([A-Z0-9]{4,12}[LR])[\s\-–]*([A-Z0-9]{4,12})[^\n]{0,36}MODEL/,
      /MODEL\s+([A-Z0-9]{10,24})/
    ];
    let tesseractLoader = null;
    let scanBusy = false;
    let scanSession = 0;
    let activeScanWorker = null;
    let warmOcrWorker = null;
    let warmOcrWorkerPromise = null;
    let geminiQuotaBlocked = false;
    let scanAbortController = null;
    let lastGeminiScanError = null;
    let scanDeadlineAt = 0;
    let scanFeedbackTimer = null;
    let lastScanSideways = false;
    const SCAN_MAX_LONG = 640;
    const SCAN_TIMEOUT_MS = 8000;
    const SCAN_DEADLINE_MS = 8000;
    const SCAN_FEEDBACK_MS = 10000;
    const OCR_IMAGE_LONG = 640;
    const OCR_DECODE_LONG = 1200;
    const OCR_RECOGNIZE_TIMEOUT_MS = 3500;
    const OCR_WORKER_TIMEOUT_MS = 12000;
    const OCR_WORKER_WAIT_MS = 3000;
    const GEMINI_CALL_TIMEOUT_MS = 6500;
    const GEMINI_IMAGE_LONG = 1200;
    const GEMINI_MODELS = [
      'gemini-3.1-flash-lite',
      'gemini-3.1-flash-lite-preview',
      'gemini-flash-latest'
    ];
    const SCAN_MIN_TIER = 3;
    const SIDEWAYS_ASPECT = 1.12;

    function clearScanFeedbackTimer() {
      if (scanFeedbackTimer) {
        clearTimeout(scanFeedbackTimer);
        scanFeedbackTimer = null;
      }
    }

    function scanFeedbackSelector() {
      const completed = $('[data-code-completed]');
      if (completed && !completed.classList.contains('hidden')) return '[data-date-feedback]';
      return '[data-feedback]';
    }

    function isCodeStepCompleted() {
      const completed = $('[data-code-completed]');
      return completed && !completed.classList.contains('hidden');
    }

    function bindFeedbackSuggestions(sel) {
      const input = $('[data-model-code]');
      const target = sel || scanFeedbackSelector();
      $$(target + ' [data-code]').forEach((btn) => {
        btn.addEventListener('click', () => {
          clearScanFeedbackTimer();
          if (input) input.value = btn.dataset.code;
          handleCheck();
        });
      });
    }

    function showTimedFeedback(html, type, sel) {
      clearScanFeedbackTimer();
      const target = sel || scanFeedbackSelector();
      if (html) {
        setFeedbackHtml(target, html, type || 'error');
        bindFeedbackSuggestions(target);
      } else {
        setFeedback(target, '', '');
      }
      scanFeedbackTimer = setTimeout(() => {
        setFeedback(target, '', '');
        scanFeedbackTimer = null;
      }, SCAN_FEEDBACK_MS);
    }

    function buildNotFoundFeedback(code) {
      const suggestions = closestCodes(code, 4);
      let html = `<span>${escapeHTML(t('notFound'))}</span>`;
      if (suggestions.length) {
        html += `<div class="aac-checker__suggestions"><strong>${escapeHTML(t('suggestions'))}</strong>${suggestions.map((entry) => `<button type="button" data-code="${escapeHTML(entry)}">${escapeHTML(entry)}</button>`).join('')}</div>`;
      }
      return html;
    }

    function finishScanLoading() {
      scanBusy = false;
      setScanLoading(false);
    }

    function isScanCancelled(session) {
      return session !== scanSession;
    }

    function isScanPastDeadline() {
      return scanDeadlineAt > 0 && Date.now() > scanDeadlineAt;
    }

    function isScanDone(session) {
      return isScanCancelled(session);
    }

    function yieldToMain() {
      return new Promise((resolve) => setTimeout(resolve, 0));
    }

    function clearScanInputs() {
      const uploadInput = $('[data-scan-file]');
      const cameraInput = $('[data-scan-camera-file]');
      if (uploadInput) uploadInput.value = '';
      if (cameraInput) cameraInput.value = '';
    }

    function cancelScan() {
      scanSession += 1;
      clearScanFeedbackTimer();
      if (scanAbortController) {
        scanAbortController.abort();
        scanAbortController = null;
      }
      if (activeScanWorker) {
        const worker = activeScanWorker;
        activeScanWorker = null;
        worker.terminate().catch(() => {});
      }
      scanBusy = false;
      setScanLoading(false);
      setScanPreview(null);
      clearScanInputs();
    }

    function isHeicFile(file) {
      if (!file) return false;
      if (/heic|heif/i.test(String(file.type || ''))) return true;
      return /\.heic$/i.test(String(file.name || ''));
    }

    function isImageFile(file) {
      if (!file) return false;
      if (file.type && file.type.startsWith('image/')) return true;
      return /\.(jpe?g|png|webp|gif|bmp|heic|heif|avif)$/i.test(String(file.name || ''));
    }

    function loadTesseract() {
      if (window.Tesseract) return Promise.resolve(window.Tesseract);
      if (tesseractLoader) return tesseractLoader;
      tesseractLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
        script.async = true;
        script.onload = () => resolve(window.Tesseract);
        script.onerror = () => reject(new Error('tesseract_load_failed'));
        document.head.appendChild(script);
      });
      return tesseractLoader;
    }

    function ensureWarmOcrWorker() {
      if (warmOcrWorker) return Promise.resolve(warmOcrWorker);
      if (warmOcrWorkerPromise) return warmOcrWorkerPromise;
      warmOcrWorkerPromise = loadTesseract()
        .then((Tesseract) => createOcrWorker(Tesseract, scanSession))
        .then((worker) => {
          if (worker) warmOcrWorker = worker;
          return worker;
        })
        .catch(() => null)
        .finally(() => {
          warmOcrWorkerPromise = null;
        });
      return warmOcrWorkerPromise;
    }

    async function createOcrWorker(Tesseract, session) {
      const worker = await Promise.race([
        Tesseract.createWorker('eng'),
        new Promise((_, reject) => {
          setTimeout(() => reject(new Error('ocr_worker_timeout')), OCR_WORKER_TIMEOUT_MS);
        })
      ]);
      if (isScanCancelled(session)) {
        worker.terminate().catch(() => {});
        return null;
      }
      await worker.setParameters({ tessedit_pageseg_mode: '11' });
      return worker;
    }

    async function recognizeCanvas(worker, canvas) {
      await yieldToMain();
      const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
      const result = await worker.recognize(dataUrl);
      return result?.data?.text || '';
    }

    function normalizeOcrText(raw) {
      return String(raw || '')
        .toUpperCase()
        .replace(/[‐‑‒–—−]/g, '-')
        .replace(/\//g, '')
        .replace(/[`'"„“”]/g, '')
        .replace(/\r/g, '\n')
        .replace(/[^\S\n]+/g, ' ')
        .replace(/\n+/g, '\n')
        .trim();
    }

    function splitMergedToyotaCode(token) {
      const flat = normalizeCode(token);
      const match = flat.match(/^([A-Z0-9]{4,12}[LR])([A-Z0-9]{4,12})$/);
      return match ? `${match[1]}-${match[2]}` : null;
    }

    function isPlausibleCodeParts(left, right) {
      if (!left || !right) return false;
      if (!/\d/.test(left)) return false;
      if (left.length < 5 || right.length < 4) return false;
      if (!/[LR]$/.test(left)) return false;
      if (/^MODEL/.test(left)) return false;
      return true;
    }

    function acceptScannedCode(candidate) {
      if (!candidate) return null;
      const normalized = normalizeCode(candidate);
      if (!normalized) return null;
      const [left, right] = normalized.split('-');
      if (!isPlausibleCodeParts(left, right)) return null;
      if (recordsByCode.has(normalized)) return normalized;
      const near = closestCodes(normalized, 3);
      for (const code of near) {
        if (!recordsByCode.has(code)) continue;
        if (levenshtein(normalized, code) <= 3) return code;
        if (ocrConfusableDistance(normalized.replace(/-/g, ''), code.replace(/-/g, '')) <= 2) return code;
      }
      return null;
    }

    function resolveExactPlateCode(candidate) {
      const normalized = normalizeCode(candidate);
      if (!normalized.includes('-')) return null;
      const [left, right] = normalized.split('-');
      return isPlausibleCodeParts(left, right) ? normalized : null;
    }

    function extractExactPlateCode(raw) {
      const upper = normalizeOcrText(raw);
      const modelAnchored = upper.match(/MODEL[\s\S]{0,80}?([A-Z0-9]{6,8}[LR]?)\s*[-–]\s*([A-Z0-9]{6,8})/);
      if (modelAnchored) {
        const exact = resolveExactPlateCode(normalizePlateCandidate(`${modelAnchored[1]}-${modelAnchored[2]}`));
        if (exact) return exact;
      }
      const modelLine = upper.match(/MODEL\s*[:\s-]*([A-Z0-9]{6,12}[LR])\s*[-–]\s*([A-Z0-9]{4,12})/);
      if (modelLine) {
        const exact = resolveExactPlateCode(`${modelLine[1]}-${modelLine[2]}`);
        if (exact) return exact;
      }
      const looseMatches = [...upper.matchAll(/([A-Z0-9]{6,8}[LR]?)\s*[-–]\s*([A-Z0-9]{6,8})/g)]
        .map((match) => normalizePlateCandidate(`${match[1]}-${match[2]}`))
        .filter(Boolean);
      for (const candidate of looseMatches) {
        const exact = resolveExactPlateCode(candidate);
        if (exact) return exact;
      }
      const directMatches = [...upper.matchAll(/[A-Z0-9]{6,12}[LR]-[A-Z0-9]{4,12}/g)]
        .map((match) => match[0])
        .sort((a, b) => b.length - a.length);
      for (const candidate of directMatches) {
        const exact = resolveExactPlateCode(candidate);
        if (exact) return exact;
      }
      return null;
    }

    function normalizePlateCandidate(candidate) {
      const normalized = normalizeCode(candidate);
      if (!normalized.includes('-')) return null;
      let [left, right] = normalized.split('-');
      if (!left || !right) return null;
      if (!/[LR]$/.test(left) && /^[A-Z0-9]{6,8}$/.test(left)) left = `${left}L`;
      if (left.length < 6 || right.length < 6) return null;
      return `${left}-${right}`;
    }

    function acceptVisionCode(candidate) {
      if (!candidate) return null;
      const exact = resolveExactPlateCode(candidate);
      if (exact && recordsByCode.has(exact)) return exact;
      return acceptScannedCode(candidate);
    }

    function candidateFromParts(left, right) {
      return acceptScannedCode(`${left}-${right}`);
    }

    function flattenSlashToken(value) {
      return String(value || '').replace(/[~\s]/g, '').split(/[/~]+/).filter(Boolean).join('');
    }

    function knownLeftParts() {
      return [...new Set([...recordsByCode.keys()].map((code) => code.split('-')[0]))];
    }

    function expandSuffixVariants(token) {
      const variants = new Set();
      const flat = normalizeCode(token);
      if (!flat) return [];
      variants.add(flat);
      if (/^AGGZW$/i.test(flat)) variants.add('AGZGZW');
      if (/^AG[^Z]?GZW$/i.test(flat)) variants.add('AGZGZW');
      if (/^AGIG/i.test(flat)) variants.add(flat.replace(/^AGIG/, 'AGZG'));
      if (/^AGFG/i.test(flat)) variants.add(flat.replace(/^AGFG/, 'AGZG'));
      if (/^AGZG$/i.test(flat)) variants.add('AGZGZW');
      if (/^(GZW|ZGZW)$/i.test(flat)) variants.add('AGZGZW');
      if (/^GW$/i.test(flat)) variants.add('GZW');
      return [...variants].filter((entry) => isLikelySuffix(entry) || entry === 'AGZGZW' || entry === 'GZW');
    }

    function dedupeSuffixTokens(tokens) {
      const expanded = new Set();
      tokens.forEach((token) => {
        expandSuffixVariants(token).forEach((variant) => expanded.add(variant));
      });
      return [...expanded];
    }

    function ocrCharCost(a, b) {
      if (a === b) return 0;
      const pair = `${a}${b}`;
      const confusable = new Set([
        '0O', 'O0', '1I', 'I1', '1L', 'L1', '5S', 'S5', '8B', 'B8', '2Z', 'Z2',
        '6G', 'G6', '0D', 'D0', 'QO', 'OQ', 'U0', '0U', 'FZ', 'ZF', 'FG', 'GF',
        'ZC', 'CZ', 'ZW', 'WZ', 'WC', 'CW', 'CV', 'VC', 'RN', 'NR', 'MN', 'NM',
        '92', '29', '12', '21', '19', '91', '16', '61', '69', '96'
      ]);
      return confusable.has(pair) ? 0.35 : 1;
    }

    function ocrConfusableDistance(a, b) {
      const left = String(a || '').toUpperCase();
      const right = String(b || '').toUpperCase();
      const dp = Array.from({ length: left.length + 1 }, () => Array(right.length + 1).fill(0));
      for (let i = 0; i <= left.length; i++) dp[i][0] = i;
      for (let j = 0; j <= right.length; j++) dp[0][j] = j;
      for (let i = 1; i <= left.length; i++) {
        for (let j = 1; j <= right.length; j++) {
          const cost = ocrCharCost(left[i - 1], right[j - 1]);
          dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
        }
      }
      return dp[left.length][right.length];
    }

    function getModelRegionRaw(raw) {
      const upper = String(raw || '').toUpperCase().replace(/[‐‑‒–—−]/g, '-').replace(/\r/g, '\n');
      const modelMatch = upper.match(/M[O0Q][D0][E3][LI1][LI1][\s\-–:.]*/i)
        || upper.match(/MODEL[\s\-–:.]*/i);
      if (!modelMatch) return '';
      return upper.slice(modelMatch.index, modelMatch.index + 140);
    }

    const LEFT_CODE_BODY = /[A-Z0-9]{4,11}\d[A-Z0-9]{0,2}[LR]/;

    function isLikelyLeftPart(token) {
      const flat = normalizeCode(token);
      return LEFT_CODE_BODY.test(flat) && /\d/.test(flat) && !/^MODEL/.test(flat);
    }

    function isLikelySuffix(token) {
      const flat = normalizeCode(token);
      if (!flat || flat.length < 4 || flat.length > 12) return false;
      if (/^MODEL/.test(flat)) return false;
      if (isLikelyLeftPart(flat)) return false;
      if (/^(GX?PA\d{1,2}|XPAT?E?)$/i.test(flat) && !/[LR]$/.test(flat)) return false;
      if (/^GXPA/i.test(flat) && !/[LR]$/.test(flat)) return false;
      return true;
    }

    function collectSuffixTokensFromModel(raw) {
      const upper = String(raw || '').toUpperCase().replace(/[‐‑‒–—−]/g, '-').replace(/\r/g, '\n');
      const region = getModelRegionRaw(raw) || upper;
      const slashTokens = new Set();
      const plainTokens = new Set();

      (upper.match(/[A-Z0-9]{1,8}[/~][A-Z0-9/]{2,12}/g) || []).forEach((part) => {
        expandSuffixVariants(flattenSlashToken(part)).forEach((token) => {
          if (isLikelySuffix(token) || token === 'AGZGZW' || token === 'GZW') slashTokens.add(token);
        });
      });

      (upper.match(/~[A-Z0-9]{3,8}/g) || []).forEach((part) => {
        expandSuffixVariants(part.replace(/[^A-Z0-9]/g, '')).forEach((token) => {
          if (isLikelySuffix(token) || token === 'AGZGZW') slashTokens.add(token);
        });
      });

      if (/\/\s*G\s*\/\s*W\b|\/G\/W/.test(upper)) {
        slashTokens.add('GZW');
        slashTokens.add('AGZGZW');
      }
      if (/AG\s*\/\s*G?ZW|G\s*\/\s*GZW/.test(upper)) {
        slashTokens.add('AGZGZW');
      }

      const linePattern = new RegExp(
        `MODEL[^A-Z0-9\\n]{0,12}(${LEFT_CODE_BODY.source})[\\s\\-–/]+([A-Z0-9/]{4,12})`
      );
      const lineMatch = region.match(linePattern);
      if (lineMatch) {
        const suffixRaw = lineMatch[2];
        const suffix = suffixRaw.replace(/[^A-Z0-9]/g, '');
        const slashSuffix = flattenSlashToken(suffixRaw);
        if (/\/|~/.test(suffixRaw)) {
          expandSuffixVariants(slashSuffix).forEach((token) => {
            if (isLikelySuffix(token) || token === 'AGZGZW') slashTokens.add(token);
          });
        } else if (isLikelySuffix(suffix)) {
          plainTokens.add(suffix);
        }
      }

      (region.match(/[A-Z0-9/]{4,14}/g) || []).forEach((part) => {
        const token = part.replace(/[^A-Z0-9]/g, '');
        if (isLikelySuffix(token)) plainTokens.add(token);
      });

      return {
        slashTokens: dedupeSuffixTokens([...slashTokens]),
        plainTokens: [...plainTokens]
      };
    }

    function fuzzyLeftTokensFromRaw(raw) {
      const upper = String(raw || '').toUpperCase().replace(/[‐‑‒–—−]/g, '-').replace(/\r/g, '\n');
      const tokens = new Set();
      const knownLefts = knownLeftParts();
      const chunks = upper.match(/[A-Z0-9]{5,12}/g) || [];

      chunks.forEach((chunk) => {
        if (/^MODEL/.test(chunk)) return;
        if (isLikelyLeftPart(chunk)) {
          tokens.add(normalizeCode(chunk));
          return;
        }
        if (/^(XPA\d{1,2}|GXPA\d{1,2})$/.test(chunk)) {
          const withSide = `${chunk}L`;
          if (isLikelyLeftPart(withSide)) tokens.add(withSide);
        }
        (chunk.match(/XPA\d{1,2}/g) || []).forEach((part) => {
          const withSide = `${part}L`;
          if (isLikelyLeftPart(withSide)) tokens.add(withSide);
        });
        knownLefts.forEach((left) => {
          if (ocrConfusableDistance(chunk, left) <= 2.5) tokens.add(left);
        });
      });

      const flat = upper.replace(/[^A-Z0-9]/g, '');
      knownLefts.forEach((left) => {
        const leftFlat = left.replace(/[^A-Z0-9]/g, '');
        if (flat.includes(leftFlat)) tokens.add(left);
        for (let len = Math.max(6, leftFlat.length - 1); len <= leftFlat.length + 1; len++) {
          if (len > 10) continue;
          for (let i = 0; i <= flat.length - len; i++) {
            if (ocrConfusableDistance(flat.slice(i, i + len), leftFlat) <= 2) tokens.add(left);
          }
        }
      });

      return [...tokens];
    }

    function collectLeftTokensFromModel(raw) {
      const upper = String(raw || '').toUpperCase().replace(/[‐‑‒–—−]/g, '-').replace(/\r/g, '\n');
      const region = getModelRegionRaw(raw) || upper;
      const tokens = new Set();
      const linePattern = new RegExp(
        `MODEL[^A-Z0-9\\n]{0,12}(${LEFT_CODE_BODY.source})[\\s\\-–/]+`
      );
      const lineMatch = region.match(linePattern);
      if (lineMatch && isLikelyLeftPart(lineMatch[1])) tokens.add(lineMatch[1]);
      (upper.match(new RegExp(`${LEFT_CODE_BODY.source}`, 'g')) || []).forEach((part) => {
        if (isLikelyLeftPart(part)) tokens.add(part);
      });
      fuzzyLeftTokensFromRaw(raw).forEach((part) => tokens.add(part));
      return [...tokens];
    }

    function codesWithLeftPrefix(left) {
      const prefix = `${normalizeCode(left)}-`;
      return [...recordsByCode.keys()].filter((code) => code.startsWith(prefix));
    }

    function bestLeftFromTokens(leftTokens) {
      if (!leftTokens.length) return null;
      const knownLefts = new Set([...recordsByCode.keys()].map((code) => code.split('-')[0]));
      const candidates = [];
      for (const token of leftTokens) {
        for (const left of knownLefts) {
          const dist = ocrConfusableDistance(token, left);
          if (dist <= 3) candidates.push({ left, dist });
        }
      }
      if (!candidates.length) return null;
      candidates.sort((a, b) => (
        a.dist - b.dist
        || (a.left.endsWith('L') && !b.left.endsWith('L') ? -1 : 0)
        || (!a.left.endsWith('L') && b.left.endsWith('L') ? 1 : 0)
      ));
      return candidates[0].left;
    }

    function resolveSiblingScanCode(raw) {
      const corpusFlat = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      const { slashTokens, plainTokens } = collectSuffixTokensFromModel(raw);
      const suffixTokens = dedupeSuffixTokens(
        slashTokens.length
          ? [...slashTokens, ...plainTokens.filter((token) => !slashTokens.includes(token))]
          : plainTokens
      );
      if (!suffixTokens.length) return null;

      let left = bestLeftFromTokens(collectLeftTokensFromModel(raw));
      if (!left) {
        const leftScores = new Map();
        for (const code of recordsByCode.keys()) {
          const [codeLeft, suffix] = code.split('-');
          for (const token of suffixTokens) {
            const dist = ocrConfusableDistance(token, suffix);
            if (dist <= 2.5) {
              let score = 3 - dist;
              if (codeLeft.endsWith('L')) score += 0.45;
              leftScores.set(codeLeft, (leftScores.get(codeLeft) || 0) + score);
            }
          }
        }
        if (leftScores.size) {
          const ranked = [...leftScores.entries()].sort((a, b) => b[1] - a[1]);
          const top = ranked[0];
          const runnerUp = ranked[1];
          if (
            runnerUp
            && top[0].slice(0, -1) === runnerUp[0].slice(0, -1)
            && top[1] - runnerUp[1] <= 2
            && runnerUp[0].endsWith('L')
          ) {
            left = runnerUp[0];
          } else {
            const topScore = top[1];
            const tied = ranked.filter((entry) => entry[1] >= topScore - 0.01);
            const lPreferred = tied.find((entry) => entry[0].endsWith('L'));
            left = lPreferred ? lPreferred[0] : top[0];
          }
        }
      }
      if (!left) return null;

      const siblings = codesWithLeftPrefix(left);
      if (!siblings.length) return null;

      let best = null;
      let bestScore = Infinity;
      const explicitLeftTokens = collectLeftTokensFromModel(raw);
      const preferredSide = explicitLeftTokens.map((token) => token.slice(-1)).find((ch) => ch === 'L' || ch === 'R');
      const tokenLooksFgNotZg = suffixTokens.some((token) => /FG/.test(token) && !/ZG/.test(token));
      const tokenLooksAgzg = suffixTokens.some((token) => /AGZG|GZW|ZG/.test(token));
      for (const sibling of siblings) {
        const suffix = sibling.split('-')[1];
        const siblingLeft = sibling.split('-')[0];
        let score = Infinity;
        for (const token of suffixTokens) {
          score = Math.min(score, ocrConfusableDistance(token, suffix));
        }
        if (corpusFlat.includes(sibling.replace('-', ''))) score -= 2;
        if (corpusFlat.includes(suffix)) score -= 1.25;
        if (corpusFlat.includes('GZW') && suffix.includes('GZW')) score -= 0.75;
        if (corpusFlat.includes('ZG') && suffix.includes('ZG')) score -= 0.5;
        if (slashTokens.length && suffix.includes('ZG')) score -= 0.35;
        if (slashTokens.length && suffix.includes('FG') && !suffix.includes('ZG')) score += 0.35;
        if (tokenLooksFgNotZg && suffix.includes('ZG')) score -= 0.45;
        if (tokenLooksFgNotZg && suffix.includes('FG') && !suffix.includes('ZG')) score += 0.3;
        if (tokenLooksAgzg && suffix.includes('GZW')) score -= 0.55;
        if (tokenLooksAgzg && suffix.includes('GZQ')) score += 0.45;
        if (slashTokens.length) score -= 0.25;
        if (preferredSide && !siblingLeft.endsWith(preferredSide)) score += 0.6;
        else if (!preferredSide && siblingLeft.endsWith('L')) score -= 0.35;
        else if (!preferredSide && siblingLeft.endsWith('R')) score += 0.2;
        if (score < bestScore) {
          bestScore = score;
          best = sibling;
        }
      }
      return bestScore <= 3 ? best : null;
    }

    function bestCodeFromCompact(compact) {
      if (!recordsByCode.size || !compact || compact.length < 10) return null;
      let best = null;
      let bestDist = Infinity;
      for (const known of recordsByCode.keys()) {
        const knownFlat = known.replace(/-/g, '');
        if (compact.includes(knownFlat)) return known;
        for (let len = knownFlat.length - 2; len <= knownFlat.length + 2; len++) {
          if (len < 10 || len > 26) continue;
          for (let i = 0; i <= compact.length - len; i++) {
            const window = compact.slice(i, i + len);
            const dist = ocrConfusableDistance(window, knownFlat);
            if (dist < bestDist) {
              bestDist = dist;
              best = known;
            }
          }
        }
      }
      return bestDist <= 5 ? best : null;
    }

    function extractAfterModelLabel(upper) {
      const modelMatch = upper.match(/M[O0][D][E3][L1][\s\-–:.]*/i);
      if (!modelMatch) return null;
      const start = modelMatch.index + modelMatch[0].length;
      const block = upper.slice(start, start + 100);
      const compact = block.replace(/[^A-Z0-9]/g, '');
      const direct = bestCodeFromCompact(compact);
      if (direct) return direct;
      for (let i = 4; i < compact.length - 4; i++) {
        if (compact[i] !== 'L' && compact[i] !== 'R') continue;
        const left = compact.slice(Math.max(0, i - 11), i + 1);
        if (!/\d/.test(left) || left.length < 5) continue;
        for (let rs = 4; rs <= 10; rs++) {
          const right = compact.slice(i + 1, i + 1 + rs);
          if (right.length < 4) continue;
          const accepted = acceptScannedCode(`${left}-${right}`);
          if (accepted) return accepted;
        }
      }
      return null;
    }

    function extractLooseCodes(upper) {
      let loose;
      CODE_LOOSE_PATTERN.lastIndex = 0;
      while ((loose = CODE_LOOSE_PATTERN.exec(upper)) !== null) {
        const accepted = candidateFromParts(loose[1], loose[2]);
        if (accepted) return accepted;
      }
      const matches = upper.match(CODE_PATTERN) || [];
      for (const match of matches) {
        const accepted = acceptScannedCode(match);
        if (accepted) return accepted;
      }
      return null;
    }

    function corpusMatchDistance(raw, code) {
      const flat = normalizeOcrText(raw).replace(/[^A-Z0-9]/g, '');
      const knownFlat = code.replace(/-/g, '');
      if (flat.includes(knownFlat)) return 0;
      let bestDist = Infinity;
      for (let len = knownFlat.length - 2; len <= knownFlat.length + 2; len++) {
        if (len < 10) continue;
        for (let i = 0; i <= flat.length - len; i++) {
          bestDist = Math.min(bestDist, ocrConfusableDistance(flat.slice(i, i + len), knownFlat));
        }
      }
      return bestDist;
    }

    function findBestCodeInCorpus(raw) {
      if (!raw || !recordsByCode.size) return null;
      const exact = extractExactPlateCode(raw);
      if (exact) return exact;

      const upper = normalizeOcrText(raw);
      const hasModelHint = /M[O0][D][E3][L1]/.test(upper);
      const siblingMatch = resolveSiblingScanCode(raw);
      const candidates = new Set();
      const tryAdd = (code) => { if (code && recordsByCode.has(code)) candidates.add(code); };

      tryAdd(siblingMatch);
      tryAdd(extractAfterModelLabel(upper));
      tryAdd(extractFromModelAnchor(upper));
      tryAdd(extractLooseCodes(upper));
      tryAdd(bestCodeFromCompact(upper.replace(/[^A-Z0-9]/g, '')));
      tryAdd(fuzzyMatchCodeFromDatabase(raw));

      let best = null;
      let bestDist = Infinity;
      for (const code of candidates) {
        const dist = corpusMatchDistance(raw, code);
        if (dist < bestDist) {
          bestDist = dist;
          best = code;
        }
      }
      if (!best) return siblingMatch || null;
      const maxDist = hasModelHint ? 5 : 4;
      if (bestDist <= maxDist) {
        if (siblingMatch && siblingMatch !== best) {
          const siblingDist = corpusMatchDistance(raw, siblingMatch);
          const { slashTokens, plainTokens } = collectSuffixTokensFromModel(raw);
          const suffixTokens = [...slashTokens, ...plainTokens];
          const fgMisread = suffixTokens.some((token) => /FG/.test(token) && !/ZG/.test(token));
          const bestSuffix = best.split('-')[1];
          const siblingSuffix = siblingMatch.split('-')[1];
          if (
            (slashTokens.length && siblingDist <= bestDist + 0.5)
            || (fgMisread
              && best.split('-')[0] === siblingMatch.split('-')[0]
              && bestSuffix.includes('FG')
              && !bestSuffix.includes('ZG')
              && siblingSuffix.includes('ZG')
              && bestDist <= 1)
          ) {
            return siblingMatch;
          }
        }
        return best;
      }
      if (siblingMatch && candidates.has(siblingMatch)) return siblingMatch;
      return null;
    }

    function extractFromModelAnchor(upper) {
      for (const pattern of MODEL_ANCHOR_PATTERNS) {
        const match = upper.match(pattern);
        if (!match) continue;
        if (match.length === 2) {
          const merged = splitMergedToyotaCode(match[1]);
          const accepted = acceptScannedCode(merged);
          if (accepted) return accepted;
          continue;
        }
        const accepted = candidateFromParts(match[1], match[2]);
        if (accepted) return accepted;
      }

      const modelIdx = upper.indexOf('MODEL');
      if (modelIdx >= 0) {
        const window = upper.slice(modelIdx, modelIdx + 96);
        const nearCode = window.match(/([A-Z0-9]{4,12}[LR])[\s\-–]*([A-Z0-9]{4,12})/);
        if (nearCode) {
          const accepted = candidateFromParts(nearCode[1], nearCode[2]);
          if (accepted) return accepted;
        }
        const merged = window.match(/MODEL[^A-Z0-9]{0,16}([A-Z0-9]{10,24})/);
        if (merged) {
          const accepted = acceptScannedCode(splitMergedToyotaCode(merged[1]));
          if (accepted) return accepted;
        }
      }
      return null;
    }

    function extractCodeFromText(raw) {
      return findBestCodeInCorpus(raw);
    }

    function fuzzyMatchCodeFromDatabase(raw) {
      if (!recordsByCode.size) return null;
      const flat = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (flat.length < 10) return null;
      const compactMatch = bestCodeFromCompact(flat);
      if (compactMatch) return compactMatch;
      for (const known of recordsByCode.keys()) {
        if (flat.includes(known.replace(/-/g, ''))) return known;
      }
      const tokens = String(raw || '').toUpperCase().match(/[A-Z0-9-]{10,26}/g) || [];
      for (const token of tokens) {
        const candidate = normalizeCode(token);
        const accepted = acceptScannedCode(candidate);
        if (accepted) return accepted;
      }
      return null;
    }

    function loadImageFromFile(file) {
      const maxLong = OCR_DECODE_LONG;
      if (typeof createImageBitmap === 'function') {
        return createImageBitmap(file, { resizeWidth: maxLong, resizeQuality: 'high' })
          .then((bitmap) => {
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
              bitmap.close?.();
              throw new Error('image_decode_failed');
            }
            ctx.drawImage(bitmap, 0, 0);
            bitmap.close?.();
            return canvas;
          })
          .catch(() => loadImageFromFileLegacy(file));
      }
      return loadImageFromFileLegacy(file);
    }

    function loadImageFromFileLegacy(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
        img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('image_load_failed')); };
        img.src = url;
      });
    }

    function imageLongEdge(source) {
      return Math.max(source.width || 1, source.height || 1);
    }

    function isLikelySidewaysUpload(img) {
      const w = img.width || img.naturalWidth || 1;
      const h = img.height || img.naturalHeight || 1;
      return h / w >= SIDEWAYS_ASPECT;
    }

    function isSidewaysRotation(rotation) {
      return rotation === 90 || rotation === 270;
    }

    function isAcceptableScanHit(hit, sideways) {
      if (!hit?.code || hit.tier < SCAN_MIN_TIER) return false;
      if (!recordsByCode.has(hit.code)) return false;
      if (sideways && !isSidewaysRotation(hit.rotation)) return false;
      return true;
    }

    function scanFailureMessage(sideways, hasCode) {
      if (hasCode) return null;
      return t('scanNoCode');
    }

    function scaleCanvasFromImage(img, maxLong) {
      const longEdge = imageLongEdge(img);
      const targetLong = Math.min(maxLong, longEdge);
      const scale = targetLong / longEdge;
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round((img.width || 1) * scale));
      canvas.height = Math.max(1, Math.round((img.height || 1) * scale));
      const ctx = canvas.getContext('2d');
      if (!ctx) return canvas;
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'medium';
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      return canvas;
    }

    function rotateCanvas(source, degrees) {
      if (!degrees) return source;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return source;
      const w = source.width;
      const h = source.height;
      const rad = (degrees * Math.PI) / 180;
      if (degrees === 90) {
        canvas.width = h;
        canvas.height = w;
        ctx.translate(h, 0);
        ctx.rotate(rad);
      } else if (degrees === 180) {
        canvas.width = w;
        canvas.height = h;
        ctx.translate(w, h);
        ctx.rotate(rad);
      } else if (degrees === 270) {
        canvas.width = h;
        canvas.height = w;
        ctx.translate(0, w);
        ctx.rotate(rad);
      } else {
        return source;
      }
      ctx.drawImage(source, 0, 0);
      return canvas;
    }

    function cropCanvas(source, xRatio, yRatio, wRatio, hRatio) {
      let x = 0;
      let y = xRatio;
      let w = 1;
      let h = yRatio;
      if (hRatio !== undefined) {
        x = xRatio;
        y = yRatio;
        w = wRatio;
        h = hRatio;
      }
      const canvas = document.createElement('canvas');
      const sx = Math.round(source.width * x);
      const sy = Math.round(source.height * y);
      const sw = Math.max(1, Math.round(source.width * w));
      const sh = Math.max(1, Math.round(source.height * h));
      canvas.width = sw;
      canvas.height = sh;
      const ctx = canvas.getContext('2d');
      if (!ctx) return canvas;
      ctx.drawImage(source, sx, sy, sw, sh, 0, 0, sw, sh);
      return canvas;
    }

    function invertGrayscaleCanvas(source) {
      const canvas = document.createElement('canvas');
      canvas.width = source.width;
      canvas.height = source.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return canvas;
      ctx.drawImage(source, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
        const boosted = gray < 110 ? Math.max(0, gray - 30) : Math.min(255, gray + 70);
        const inverted = 255 - boosted;
        data[i] = data[i + 1] = data[i + 2] = inverted;
      }
      ctx.putImageData(imageData, 0, 0);
      return canvas;
    }

    function detectDarkPlateCrop(source) {
      const { width, height } = source;
      const ctx = source.getContext('2d');
      if (!ctx) return source;
      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;
      let minX = width;
      let minY = height;
      let maxX = 0;
      let maxY = 0;
      let count = 0;
      const step = width * height > 900000 ? 2 : 1;
      for (let y = 0; y < height; y += step) {
        for (let x = 0; x < width; x += step) {
          const i = (y * width + x) * 4;
          if (data[i] < 60 && data[i + 1] < 60 && data[i + 2] < 60) {
            count++;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }
      if (count < 120) return source;
      const pad = Math.round(Math.max(maxX - minX, maxY - minY) * 0.03);
      const sx = Math.max(0, minX - pad);
      const sy = Math.max(0, minY - pad);
      const sw = Math.min(width, maxX + pad) - sx;
      const sh = Math.min(height, maxY + pad) - sy;
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, sw);
      canvas.height = Math.max(1, sh);
      const out = canvas.getContext('2d');
      if (!out) return source;
      out.drawImage(source, sx, sy, sw, sh, 0, 0, sw, sh);
      return canvas;
    }

    async function recognizeCanvasWithTimeout(worker, canvas, session, timeoutMs = OCR_RECOGNIZE_TIMEOUT_MS) {
      if (!worker || isScanDone(session)) return '';
      return Promise.race([
        recognizeCanvas(worker, canvas),
        new Promise((resolve) => { setTimeout(() => resolve(''), timeoutMs); })
      ]);
    }

    async function buildLightOcrTarget(scaled, rotation) {
      await yieldToMain();
      const base = rotation ? rotateCanvas(scaled, rotation) : scaled;
      await yieldToMain();
      const modelBand = cropCanvas(base, 0.4, 0.52);
      return invertGrayscaleCanvas(modelBand);
    }

    function parseOcrCollected(collected) {
      const joined = collected.filter(Boolean).join('\n');
      if (!joined) return null;
      const exact = extractExactPlateCode(joined);
      if (exact) return exact;
      return findBestCodeInCorpus(joined);
    }

    async function ensureScanWorker(session) {
      if (warmOcrWorker) return warmOcrWorker;
      return Promise.race([
        ensureWarmOcrWorker(),
        new Promise((resolve) => { setTimeout(() => resolve(null), OCR_WORKER_WAIT_MS); })
      ]).then((worker) => {
        if (worker && isScanCancelled(session)) return null;
        return worker;
      });
    }

    async function recognizeWithLocalOcr(img, session) {
      await yieldToMain();
      if (isScanDone(session)) return null;

      const worker = await ensureScanWorker(session);
      if (!worker || isScanDone(session)) return null;

      const portrait = (img.height || 1) > (img.width || 1) * 1.05;
      const rotations = portrait ? [90, 270] : [0];
      const collected = [];
      await yieldToMain();
      const scaled = scaleCanvasFromImage(img, OCR_IMAGE_LONG);

      for (const rotation of rotations) {
        if (isScanDone(session)) return null;
        const target = await buildLightOcrTarget(scaled, rotation);
        if (isScanDone(session)) return null;
        const text = await recognizeCanvasWithTimeout(worker, target, session);
        if (text) collected.push(text);
        const code = parseOcrCollected(collected);
        if (code) return code;
      }

      return parseOcrCollected(collected);
    }

    function buildGeminiScanCanvases(img) {
      const scaled = scaleCanvasFromImage(img, GEMINI_IMAGE_LONG);
      const portrait = (img.height || 1) > (img.width || 1) * 1.05;
      if (!portrait) return [scaled];
      return [rotateCanvas(scaled, 90), rotateCanvas(scaled, 270)];
    }

    async function buildScanAssets(img, session) {
      if (isScanDone(session)) return null;
      await yieldToMain();
      const scaled = scaleCanvasFromImage(img, SCAN_MAX_LONG);
      const crop = detectDarkPlateCrop(scaled);
      const portrait = crop.height > crop.width * 1.05;
      const oriented = portrait ? rotateCanvas(crop, 90) : crop;
      const modelLine = invertGrayscaleCanvas(cropCanvas(oriented, 0.48, 0.46));
      const geminiScaled = scaleCanvasFromImage(img, GEMINI_VISION_LONG);
      const geminiCrop = detectDarkPlateCrop(geminiScaled);
      const geminiCanvas = portrait ? rotateCanvas(geminiCrop, 90) : geminiCrop;
      return { oriented, modelLine, geminiCanvas, portrait };
    }

    async function prepareScanImage(img, session) {
      const assets = await buildScanAssets(img, session);
      return assets?.oriented || null;
    }

    function buildFastOcrAttempts(plate) {
      const inverted = invertGrayscaleCanvas(plate);
      const portrait = plate.height > plate.width * 1.05;
      const attempts = [inverted];
      if (portrait) {
        attempts.push(rotateCanvas(inverted, 90));
        attempts.push(rotateCanvas(inverted, 270));
      }
      attempts.push(cropCanvas(inverted, portrait ? 0.28 : 0.52, portrait ? 0.5 : 0.38));
      return attempts;
    }

    async function recognizeWithTesseract(Tesseract, img, session) {
      const plate = await prepareScanImage(img, session);
      if (!plate || isScanCancelled(session)) return null;

      let worker = null;
      const collected = [];
      const attempts = buildFastOcrAttempts(plate);
      try {
        worker = await createOcrWorker(Tesseract, session);
        if (!worker || isScanCancelled(session)) throw new Error('ocr_worker_unavailable');

        for (const target of attempts) {
          if (isScanDone(session)) return null;
          await yieldToMain();
          const text = await recognizeCanvas(worker, target);
          if (text) collected.push(text);
          const code = findBestCodeInCorpus(collected.join('\n'));
          if (code) return code;
        }
      } catch (e) {
        if (isScanDone(session)) return null;
        for (const target of attempts.slice(0, 2)) {
          await yieldToMain();
          const dataUrl = target.toDataURL('image/png');
          const result = await Tesseract.recognize(dataUrl, 'eng', { logger: () => {} });
          const text = result?.data?.text || '';
          if (text) collected.push(text);
          const code = findBestCodeInCorpus(collected.join('\n'));
          if (code) return code;
        }
      } finally {
        if (worker) {
          await worker.terminate().catch(() => {});
          if (activeScanWorker === worker) activeScanWorker = null;
        }
      }
      return isScanCancelled(session) ? null : findBestCodeInCorpus(collected.join('\n'));
    }

    function canvasToJpegBlob(canvas, quality) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality);
      });
    }

    async function buildPrimaryVisionCanvases(file, session) {
      const img = await loadImageFromFile(file);
      if (isScanCancelled(session)) return [];
      await yieldToMain();
      const scaled = scaleCanvasFromImage(img, GEMINI_VISION_LONG);
      const crop = detectDarkPlateCrop(scaled);
      const portrait = scaled.height > scaled.width * 1.05;
      const primary = portrait ? rotateCanvas(crop, 90) : crop;
      const secondary = portrait ? rotateCanvas(scaled, 90) : scaled;
      return [primary, secondary];
    }

    async function buildVisionVariants(file, session) {
      const img = await loadImageFromFile(file);
      if (isScanCancelled(session)) return [];
      await yieldToMain();
      const scaled = scaleCanvasFromImage(img, 2048);
      const crop = detectDarkPlateCrop(scaled);
      const portrait = scaled.height > scaled.width * 1.05;
      const variants = [crop, scaled];
      if (portrait) {
        variants.unshift(rotateCanvas(crop, 90));
        variants.unshift(rotateCanvas(scaled, 90));
      } else {
        variants.push(rotateCanvas(crop, 90));
      }
      const unique = [];
      const seen = new Set();
      for (const canvas of variants) {
        const key = `${canvas.width}x${canvas.height}`;
        if (seen.has(key)) continue;
        seen.add(key);
        unique.push(canvas);
      }
      return unique.slice(0, 4);
    }

    async function visionImageBlob(file, session) {
      const variants = await buildVisionVariants(file, session);
      if (!variants.length) return null;
      return canvasToJpegBlob(variants[0], 0.92);
    }

    function blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const dataUrl = String(reader.result || '');
          resolve(dataUrl.split(',')[1] || '');
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    function getGeminiApiKey() {
      return String(root.dataset.checkerGeminiKey || config.geminiApiKey || '').trim();
    }

    function noteRawScanText(sink, raw) {
      const text = String(raw || '').trim();
      if (sink && text && text.length >= 4) sink.push(text);
    }

    function gatherVerificationCandidates(rawTexts, limit = 8) {
      if (!recordsByCode.size || !rawTexts?.length) return [];
      const scores = new Map();
      for (const raw of rawTexts) {
        const corpusHit = findBestCodeInCorpus(raw);
        if (corpusHit) {
          scores.set(corpusHit, 0);
          continue;
        }
      }
      return [...scores.keys()].slice(0, limit);
    }

    function pickBestScanResult(jobs, session, sideways) {
      return Promise.all(
        jobs.map((job) => Promise.resolve(job()).catch(() => null))
      ).then((hits) => {
        if (isScanCancelled(session)) return null;
        let best = null;
        for (const hit of hits) {
          if (!hit?.code) continue;
          if (!best) {
            best = hit;
            continue;
          }
          if (hit.tier > best.tier) {
            best = hit;
            continue;
          }
          if (hit.tier === best.tier && sideways) {
            const hitSideways = isSidewaysRotation(hit.rotation);
            const bestSideways = isSidewaysRotation(best.rotation);
            if (hitSideways && !bestSideways) best = hit;
          }
        }
        return best;
      });
    }

    function interpretVisionText(raw, rawSink) {
      noteRawScanText(rawSink, raw);
      const text = String(raw || '').trim().replace(/```[a-z]*\n?/gi, '').replace(/```/g, '').trim();
      if (!text || /^NO_(CODE|MATCH)$/i.test(text)) return null;

      const stripped = text.replace(/[^A-Z0-9-–]/gi, '').replace(/-+/g, '-').toUpperCase();
      const onlyCode = /^[A-Z0-9]{6,12}[LR]-[A-Z0-9]{4,12}$/.test(stripped);

      const exact = extractExactPlateCode(text);
      if (exact) {
        const hasModel = /MODEL|MODELL/i.test(text);
        const tier = onlyCode ? 4 : hasModel ? 3 : 2;
        return { code: exact, tier };
      }

      const modelRegion = getModelRegionRaw(text);
      if (modelRegion) {
        const fromModel = extractExactPlateCode(modelRegion);
        if (fromModel) return { code: fromModel, tier: 3 };
      }

      const normalized = normalizePlateCandidate(text.replace(/[^A-Z0-9-–]/gi, '-').replace(/-+/g, '-'));
      if (normalized) {
        const resolved = resolveExactPlateCode(normalized);
        if (resolved) return { code: resolved, tier: onlyCode ? 4 : 2 };
      }

      return null;
    }

    function parseVisionCode(raw) {
      const hit = interpretVisionText(raw, null);
      return hit?.code || null;
    }

    function interpretVerifyResponse(raw, candidates, rawSink) {
      noteRawScanText(rawSink, raw);
      const upper = String(raw || '').trim().toUpperCase().replace(/```[A-Z]*\n?/g, '').replace(/```/g, '').trim();
      if (!upper || upper === 'NO_MATCH' || upper === 'NO_CODE') return null;

      const direct = upper.match(/[A-Z0-9]{4,12}[LR]-[A-Z0-9]{4,12}/);
      if (direct && candidates.includes(direct[0])) return direct[0];

      for (const code of candidates) {
        if (upper.includes(code)) return code;
        const flat = upper.replace(/[^A-Z0-9]/g, '');
        const codeFlat = code.replace(/-/g, '');
        if (flat.includes(codeFlat)) return code;
        if (ocrConfusableDistance(flat, codeFlat) <= 2) return code;
      }
      return null;
    }

    async function geminiRequest(apiKey, model, base64, mimeType, prompt, session, rawSink, verifyCandidates) {
      if (geminiQuotaBlocked) return null;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), GEMINI_CALL_TIMEOUT_MS);
      try {
        const response = await fetch(
          `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent`,
          {
            method: 'POST',
            signal: controller.signal,
            headers: {
              'Content-Type': 'application/json',
              'x-goog-api-key': apiKey
            },
            body: JSON.stringify({
              contents: [{
                parts: [
                  { text: prompt },
                  { inline_data: { mime_type: mimeType, data: base64 } }
                ]
              }],
              generationConfig: { temperature: 0, maxOutputTokens: 64 }
            })
          }
        );
        if (!response.ok) {
          const errBody = await response.json().catch(() => ({}));
          const msg = String(errBody?.error?.message || '');
          if (response.status === 404 || /not found|no longer available|not supported/i.test(msg)) {
            lastGeminiScanError = 'model_not_found';
          } else if (response.status === 403 || /referrer|api key|permission|denied/i.test(msg)) {
            lastGeminiScanError = 'key_rejected';
          } else if (response.status === 429 || /quota|rate limit|billing|high demand/i.test(msg)) {
            lastGeminiScanError = 'quota_exceeded';
            if (/quota|rate limit|billing/i.test(msg)) geminiQuotaBlocked = true;
          }
          return null;
        }
        if (isScanDone(session)) return null;
        const data = await response.json();
        const raw = data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
        if (verifyCandidates?.length) {
          return interpretVerifyResponse(raw, verifyCandidates, rawSink);
        }
        return interpretVisionText(raw, rawSink);
      } catch (e) {
        if (e?.name === 'AbortError' && isScanCancelled(session)) return null;
        return null;
      } finally {
        clearTimeout(timer);
      }
    }

    function geminiPrompts() {
      if (currentLang === 'de') {
        return {
          scan: 'Lies das Typenschild auf dem Foto. Das Bild kann gedreht sein (90°, 180° oder 270°). Suche die Zeile mit MODEL — unabhängig von der Bildausrichtung. Der Modellcode steht direkt daneben: 6–7 Zeichen, Minus, 6–7 Zeichen. Beispiel: MZEH12L-DWXGBW. Nur den Code zurückgeben oder NO_CODE.',
          verify: (list) => `Welcher Code steht auf der MODEL-Zeile des Typenschilds?\n\n${list}\n\nAntwort NUR mit exakt einem Code aus der Liste oder NO_MATCH.`
        };
      }
      return {
        scan: 'Read the type plate in this photo. The image may be rotated (90°, 180°, or 270°). Find the line labeled MODEL regardless of orientation. The model code is next to it: 6–7 characters, hyphen, 6–7 characters. Example: MZEH12L-DWXGBW. Return only the code or NO_CODE.',
        verify: (list) => `Which code is printed on the MODEL line of the type plate?\n\n${list}\n\nReply ONLY with one exact code from the list or NO_MATCH.`
      };
    }

    async function sendGeminiCanvas(canvas, apiKey, model, prompt, session, rawSink) {
      if (isScanCancelled(session)) return null;
      const blob = await canvasToJpegBlob(canvas, 0.92);
      if (!blob || isScanCancelled(session)) return null;
      const base64 = await blobToBase64(blob);
      if (!base64) return null;
      return geminiRequest(apiKey, model, base64, 'image/jpeg', prompt, session, rawSink);
    }

    async function recognizeWithGeminiFast(img, session, rawSink, sideways) {
      const apiKey = getGeminiApiKey();
      if (!apiKey || isScanCancelled(session)) {
        lastGeminiScanError = apiKey ? null : 'missing_key';
        return null;
      }

      await yieldToMain();
      const scaled = scaleCanvasFromImage(img, GEMINI_IMAGE_LONG);
      const sidewaysUpload = sideways ?? isLikelySidewaysUpload(scaled);
      const rotations = [0, 90, 180, 270];
      const prompts = geminiPrompts();
      scanAbortController = new AbortController();

      for (const model of GEMINI_MODELS) {
        if (isScanCancelled(session)) return null;
        const jobs = rotations.map((rotation) => () => {
          const canvas = rotation ? rotateCanvas(scaled, rotation) : scaled;
          return sendGeminiCanvas(canvas, apiKey, model, prompts.scan, session, rawSink)
            .then((hit) => (hit ? { ...hit, rotation } : null));
        });
        const hit = await pickBestScanResult(jobs, session, sidewaysUpload);
        if (hit) {
          lastGeminiScanError = null;
          return hit;
        }
        if (geminiQuotaBlocked) return null;
      }
      return null;
    }

    async function recognizeWithFastOcr(assets, session, rawSink) {
      if (!assets?.modelLine || isScanDone(session)) return null;

      const worker = warmOcrWorker;
      if (!worker) return null;

      const targets = [assets.modelLine];
      const collected = [];
      for (const target of targets) {
        if (isScanDone(session)) return null;
        await yieldToMain();
        const text = await recognizeCanvasWithTimeout(worker, target, session);
        if (!text) continue;
        collected.push(text);
        noteRawScanText(rawSink, text);
        const exact = extractExactPlateCode(collected.join('\n'));
        if (exact) return exact;
        const code = findBestCodeInCorpus(collected.join('\n'));
        if (code) return code;
      }
      return extractExactPlateCode(collected.join('\n')) || findBestCodeInCorpus(collected.join('\n'));
    }

    async function recognizeWithWarmOcr(img, session, rawSink) {
      const assets = await buildScanAssets(img, session);
      if (!assets) return null;
      return recognizeWithFastOcr(assets, session, rawSink);
    }

    async function recognizeWithTesseractQuick(Tesseract, img, session, rawSink) {
      return recognizeWithWarmOcr(img, session, rawSink);
    }

    function stopBackgroundScanWork() {
      if (scanAbortController) {
        scanAbortController.abort();
        scanAbortController = null;
      }
      if (activeScanWorker) {
        const worker = activeScanWorker;
        activeScanWorker = null;
        worker.terminate().catch(() => {});
      }
    }

    async function recognizePlateFromFile(file, session) {
      lastGeminiScanError = null;
      const img = await loadImageFromFile(file);
      lastScanSideways = isLikelySidewaysUpload(img);
      if (isScanDone(session)) return { ok: false, sideways: lastScanSideways };
      const hit = await recognizeWithGeminiFast(img, session, [], lastScanSideways);
      if (!hit) return { ok: false, sideways: lastScanSideways };
      if (!isAcceptableScanHit(hit, lastScanSideways)) {
        return { ok: false, sideways: lastScanSideways, rejectedCode: hit.code };
      }
      return { ok: true, code: hit.code, sideways: lastScanSideways };
    }

    function setScanPreview(file) {
      const preview = $('[data-scan-preview]');
      const img = $('[data-scan-preview-img]');
      if (!preview || !img) return;
      if (preview.__aacPreviewUrl) {
        URL.revokeObjectURL(preview.__aacPreviewUrl);
        preview.__aacPreviewUrl = null;
      }
      if (!file) {
        preview.classList.add('hidden');
        img.removeAttribute('src');
        return;
      }
      const url = URL.createObjectURL(file);
      preview.__aacPreviewUrl = url;
      img.src = url;
      preview.classList.remove('hidden');
    }

    function paintScanLoading() {
      return new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
      });
    }

    function setScanLoading(active) {
      const uploadBtn = $('[data-scan-upload]');
      const cameraBtn = $('[data-scan-camera]');
      const input = $('[data-model-code]');
      const checkBtn = $('[data-check-btn]');
      const inputRow = $('.aac-checker__input-row');

      uploadBtn?.classList.toggle('is-loading', active);
      cameraBtn?.classList.toggle('is-loading', active);
      if (uploadBtn) uploadBtn.disabled = active;
      if (cameraBtn) cameraBtn.disabled = active;
      if (input) {
        input.disabled = active;
        input.readOnly = active;
      }
      if (checkBtn) checkBtn.disabled = active;
      $('[data-scan-reupload]')?.classList.toggle('is-loading', active);
      if ($('[data-scan-reupload]')) $('[data-scan-reupload]').disabled = active;
      inputRow?.classList.toggle('is-scanning', active);
      root.classList.toggle('is-scanning', active);
      root.classList.toggle('is-scan-busy', active);
      root.closest('.mainproduct-vehicles-modal__card')?.classList.toggle('is-scanning', active);
    }

    function openScanPicker(triggerInput) {
      triggerInput?.click();
    }

    function handleScanReupload() {
      if (scanBusy) return;
      clearScanFeedbackTimer();
      $('[data-model-code]').value = '';
      setFeedback('[data-feedback]', '');
      setFeedback('[data-date-feedback]', '');
      resetAfterCode();
      requestAnimationFrame(() => openScanPicker($('[data-scan-file]')));
    }

    function resetStepsAfterCodeChange() {
      ['display', 'result'].forEach((name) => $('[data-panel="' + name + '"]').classList.add('hidden'));
      $('[data-panel="date"]')?.classList.remove('hidden');
      resetStepPanel('date', '[data-date-completed]', '[data-date-active]');
      resetStepPanel('display', '[data-display-completed]', '[data-display-active]');
      $('[data-details-grid]').innerHTML = '';
      $('[data-details-block]')?.classList.add('hidden');
      const visual = $('[data-vehicle-visual]');
      if (visual) { visual.innerHTML = ''; visual.classList.add('hidden'); }
      $('[data-display-choices]').innerHTML = '';
      $('[data-reset-btn]')?.classList.add('hidden');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      state.selectedDate = null;
      state.eligibleRows = [];
      state.selectedDisplay = null;
      state.lastResult = null;
      setFeedback('[data-date-feedback]', '');
      setFeedback('[data-display-hint]', '');
      setActiveStep('date');
    }

    function applyScannedCode(code, queueFeedback, options) {
      const opts = options || {};
      const validation = validateModelCode(code);
      if (!validation.ok) {
        const input = $('[data-model-code]');
        if (input) input.value = '';
        const msg = scanFailureMessage(opts.sideways, false) || t('scanNoCode');
        const html = `<span>${escapeHTML(msg)}</span>`;
        if (queueFeedback) queueFeedback(html, 'error');
        else showTimedFeedback(html, 'error');
        return false;
      }

      const input = $('[data-model-code]');
      if (input) {
        input.value = validation.code;
        input.classList.remove('is-invalid');
      }

      const matches = recordsByCode.get(validation.code) || [];
      if (!matches.length) {
        showNotFound(validation.code, 'photo');
        return false;
      }

      clearScanFeedbackTimer();
      setFeedback('[data-feedback]', '', '');
      setFeedback('[data-date-feedback]', '', '');

      const reupload = isCodeStepCompleted();
      if (reupload) resetStepsAfterCodeChange();

      state.matches = matches;
      state.selectedCode = validation.code;
      completeCodePanel(validation.code);
      renderDetails(matches);

      if (aggregateSupport(matches) === 'NO') {
        renderResult('NO', '');
        return true;
      }

      $('[data-panel="date"]').classList.remove('hidden');
      setActiveStep('date');
      return true;
    }

    async function processScanFile(file) {
      if (scanBusy || !file) return;
      if (isHeicFile(file)) {
        setScanPreview(null);
        setFeedback('[data-feedback]', t('scanError'), 'error');
        return;
      }
      if (!isImageFile(file)) {
        setScanPreview(null);
        setFeedback('[data-feedback]', t('scanError'), 'error');
        return;
      }
      if (!recordsByCode.size) {
        setFeedback('[data-feedback]', config.loadError || t('scanError'), 'error');
        return;
      }

      scanSession += 1;
      const session = scanSession;
      geminiQuotaBlocked = false;
      scanBusy = true;
      scanDeadlineAt = Date.now() + SCAN_DEADLINE_MS;
      const input = $('[data-model-code]');
      setScanPreview(null);
      setScanLoading(true);
      clearScanFeedbackTimer();
      setFeedback('[data-feedback]', '', '');
      setFeedback('[data-date-feedback]', '', '');
      await paintScanLoading();

      let pendingFeedback = null;
      const feedbackSel = scanFeedbackSelector();
      const queueFeedback = (html, type) => { pendingFeedback = { html, type, sel: feedbackSel }; };
      const loadStartedAt = Date.now();
      let userCancelled = false;

      try {
        const scanTimeout = SCAN_TIMEOUT_MS;
        const result = await Promise.race([
          recognizePlateFromFile(file, session),
          new Promise((resolve) => { setTimeout(() => resolve({ ok: false, timeout: true, sideways: lastScanSideways }), scanTimeout); })
        ]);

        if (isScanCancelled(session)) {
          userCancelled = true;
        } else if (!result?.ok) {
          stopBackgroundScanWork();
          setScanPreview(null);
          if (input) input.value = '';
          const sideways = result?.sideways || lastScanSideways;
          const msg = scanFailureMessage(sideways, Boolean(result?.rejectedCode)) || t('scanNoCode');
          queueFeedback(`<span>${escapeHTML(msg)}</span>`, 'error');
        } else {
          setScanPreview(null);
          applyScannedCode(result.code, queueFeedback, { sideways: result.sideways });
        }
      } catch (e) {
        if (isScanCancelled(session)) {
          userCancelled = true;
        } else {
          stopBackgroundScanWork();
          setScanPreview(null);
          if (input) input.value = '';
          queueFeedback(`<span>${escapeHTML(t('scanError'))}</span>`, 'error');
        }
      } finally {
        stopBackgroundScanWork();
        if (session === scanSession) clearScanInputs();
      }

      if (!userCancelled) {
        const minVisibleMs = 450;
        const elapsed = Date.now() - loadStartedAt;
        if (elapsed < minVisibleMs) {
          await new Promise((resolve) => { setTimeout(resolve, minVisibleMs - elapsed); });
        }
      }

      finishScanLoading();

      if (!userCancelled && pendingFeedback) {
        showTimedFeedback(pendingFeedback.html, pendingFeedback.type, pendingFeedback.sel);
      }
    }

    function handleScanInputChange(e) {
      const file = e.target?.files?.[0];
      if (file) processScanFile(file);
    }

    function setFeedback(sel, message, type) {
      const el = $(sel);
      if (!el) return;
      el.textContent = message || '';
      el.className = 'aac-checker__feedback' + (type ? ' is-' + type : '');
    }

    function setFeedbackHtml(sel, html, type) {
      const el = $(sel);
      if (!el) return;
      el.innerHTML = html || '';
      el.className = 'aac-checker__feedback' + (type ? ' is-' + type : '');
    }

    function setActiveStep(step) {
      $$('[data-step]').forEach((el) => el.classList.toggle('is-active', el.dataset.step === step));
      updateStepperNav();
    }

    function getCurrentStepIndex() {
      const active = $('[data-step].is-active');
      if (!active) return 0;
      const idx = STEP_ORDER.indexOf(active.dataset.step);
      return idx >= 0 ? idx : 0;
    }

    function updateStepperNav() {
      const currentIdx = getCurrentStepIndex();
      $$('[data-step]').forEach((el) => {
        const idx = STEP_ORDER.indexOf(el.dataset.step);
        const isActive = el.classList.contains('is-active');
        const isPast = idx >= 0 && idx < currentIdx;
        el.classList.toggle('is-clickable', isPast);
        el.disabled = !isActive && !isPast;
      });
    }

    function goBackToCodeStep() {
      cancelScan();
      exitMissFlow();
      ['date', 'display', 'result', 'detected'].forEach((name) => $('[data-panel="' + name + '"]')?.classList.add('hidden'));
      $('[data-panel="code"]')?.classList.remove('hidden');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      resetStepPanel('code', '[data-code-completed]', '[data-code-active]');
      resetStepPanel('date', '[data-date-completed]', '[data-date-active]');
      resetStepPanel('display', '[data-display-completed]', '[data-display-active]');
      $('[data-details-block]')?.classList.add('hidden');
      const visual = $('[data-vehicle-visual]');
      if (visual) { visual.innerHTML = ''; visual.classList.add('hidden'); }
      $('[data-reset-btn]')?.classList.add('hidden');
      if ($('[data-result-box]')) $('[data-result-box]').innerHTML = '';
      state.selectedDate = null;
      state.selectedDisplay = null;
      state.lastResult = null;
      state.eligibleRows = [];
      setFeedback('[data-date-feedback]', '');
      setFeedback('[data-display-hint]', '');
      setActiveStep('code');
    }

    function goBackToDateStep() {
      cancelScan();
      ['display', 'result', 'detected'].forEach((name) => $('[data-panel="' + name + '"]')?.classList.add('hidden'));
      $('[data-panel="code"]')?.classList.remove('hidden');
      $('[data-panel="date"]')?.classList.remove('hidden');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      resetStepPanel('date', '[data-date-completed]', '[data-date-active]');
      resetStepPanel('display', '[data-display-completed]', '[data-display-active]');
      $('[data-reset-btn]')?.classList.add('hidden');
      if ($('[data-result-box]')) $('[data-result-box]').innerHTML = '';
      state.selectedDisplay = null;
      state.lastResult = null;
      state.eligibleRows = state.matches.slice();
      setFeedback('[data-display-hint]', '');
      setActiveStep('date');
    }

    function goBackToDisplayStep() {
      ['result', 'detected'].forEach((name) => $('[data-panel="' + name + '"]')?.classList.add('hidden'));
      $('[data-panel="code"]')?.classList.remove('hidden');
      $('[data-panel="date"]')?.classList.remove('hidden');
      $('[data-panel="display"]')?.classList.remove('hidden');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      resetStepPanel('display', '[data-display-completed]', '[data-display-active]');
      $('[data-reset-btn]')?.classList.add('hidden');
      if ($('[data-result-box]')) $('[data-result-box]').innerHTML = '';
      state.lastResult = null;
      if (state.eligibleRows.length && requiresDisplay(state.eligibleRows)) {
        renderDisplayStep(state.eligibleRows);
      }
      setActiveStep('display');
    }

    function navigateToStep(targetStep) {
      const targetIdx = STEP_ORDER.indexOf(targetStep);
      const currentIdx = getCurrentStepIndex();
      if (targetIdx < 0 || targetIdx >= currentIdx) return;
      if (targetStep === 'code') goBackToCodeStep();
      else if (targetStep === 'date') goBackToDateStep();
      else if (targetStep === 'display') goBackToDisplayStep();
    }

    function getCheckoutVariantId() {
      return Number(root.getAttribute('data-checker-variant-id') || config.checkoutVariantId || 0);
    }

    function collectCheckoutProperties() {
      const props = {};
      if (window.BTECH_LOCALE) props._Locale = window.BTECH_LOCALE;
      props['_Source page'] = window.location.pathname;
      if (state.selectedCode) props['_Model code check'] = state.selectedCode;
      document.querySelectorAll('input[name^="properties["]').forEach((cb) => {
        if (cb.hasAttribute('data-mem-cb')) return;
        if (!cb.checked) return;
        const name = cb.getAttribute('name');
        const key = name?.match(/^properties\[(.*)\]$/)?.[1];
        if (key) props[key] = cb.value;
      });
      return props;
    }

    async function proceedToCheckout(btn) {
      if (checkoutBusy) return;
      const variantId = getCheckoutVariantId();
      if (!variantId) return;
      checkoutBusy = true;
      btn.disabled = true;
      btn.classList.add('is-loading');
      const buyButton = document.querySelector('.mainproduct-buy-button');
      const memCB = document.querySelector('[data-mem-cb]');
      const addonId = Number(buyButton?.dataset.variantMemory || 0);
      const addAddon = !!(memCB && memCB.checked && addonId);
      const qtyWrap = document.querySelector('[data-mem-qty]');
      const qtyInput = qtyWrap?.querySelector('.mainproduct-qty__input');
      const qtyMin = Math.max(1, Number(qtyWrap?.dataset.min || 1));
      const qtyMax = Math.max(qtyMin, Number(qtyWrap?.dataset.max || 99));
      let orderQty = parseInt(String(qtyInput?.value || '1'), 10);
      if (Number.isNaN(orderQty)) orderQty = qtyMin;
      orderQty = Math.min(qtyMax, Math.max(qtyMin, orderQty));
      const items = [{ id: variantId, quantity: orderQty, properties: collectCheckoutProperties() }];
      if (addAddon) items.push({ id: addonId, quantity: orderQty, properties: {} });
      try {
        let cleared = false;
        while (!cleared) {
          const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
          if (clearRes.ok) cleared = true;
        }
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!addRes.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      } catch (e) {
        checkoutBusy = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        alert(t('checkoutError'));
      }
    }

    function bindCheckoutButton() {
      $('[data-checker-checkout]')?.addEventListener('click', (e) => proceedToCheckout(e.currentTarget));
    }

    function closeSystemTips(exceptBtn) {
      $$('[data-sys-tip-btn]').forEach((btn) => {
        if (btn === exceptBtn) return;
        btn.setAttribute('aria-expanded', 'false');
        const item = btn.closest('.aac-sys__item');
        const tip = item?.querySelector('[data-sys-tip]');
        if (tip) tip.hidden = true;
      });
    }

    function canHoverSystemTips() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function placeSystemTip(item) {
      if (!item) return;
      const tip = item.querySelector('[data-sys-tip]');
      if (!tip || tip.hidden) return;
      if (item.classList.contains('aac-sys__item--tip-up')) return;
      const card = item.closest('.aac-sys');
      const checkout = $('[data-checker-checkout]');
      const tipRect = tip.getBoundingClientRect();
      const cardBottom = card ? card.getBoundingClientRect().bottom : Infinity;
      const checkoutTop = checkout ? checkout.getBoundingClientRect().top : Infinity;
      if (tipRect.bottom > cardBottom - 6 || tipRect.bottom > checkoutTop - 10) {
        item.classList.add('aac-sys__item--tip-up');
      }
    }

    function openSystemTip(btn) {
      const item = btn.closest('.aac-sys__item');
      const tip = item?.querySelector('[data-sys-tip]');
      if (!tip) return;
      closeSystemTips(btn);
      btn.setAttribute('aria-expanded', 'true');
      tip.hidden = false;
      placeSystemTip(item);
    }

    function bindSystemTips() {
      const hover = canHoverSystemTips();
      $$('[data-sys-tip-btn]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (hover) return;
          const open = btn.getAttribute('aria-expanded') === 'true';
          if (open) closeSystemTips();
          else openSystemTip(btn);
        });
        if (hover) {
          btn.addEventListener('mouseenter', () => openSystemTip(btn));
          btn.addEventListener('mouseleave', () => closeSystemTips());
        }
      });
      $('.aac-sys')?.addEventListener('toggle', (e) => {
        if (!e.currentTarget.open) closeSystemTips();
      });
    }

    function sysCopy(id, field) {
      return t('sys.' + id + '.' + field);
    }

    function renderSystemItem(id, state, tipUp) {
      const name = sysCopy(id, 'name');
      const short = sysCopy(id, 'short');
      const tip = id === 'dms' && state === 'autolearn' ? t('sys.dmsLearn') : sysCopy(id, 'tip');
      const learn = state === 'autolearn'
        ? `<span class="aac-sys__learn">${escapeHTML(t('systemsAutoLearn'))}</span>`
        : '';
      const shortHtml = short
        ? `<span class="aac-sys__short">${escapeHTML(short)}</span>`
        : '';
      const itemClass = tipUp ? 'aac-sys__item aac-sys__item--tip-up' : 'aac-sys__item';
      return `<li class="${itemClass}">
        <span class="aac-sys__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>
        </span>
        <span class="aac-sys__copy">
          <span class="aac-sys__name">${escapeHTML(name)}</span>
          ${shortHtml}
          ${learn}
        </span>
        <button type="button" class="aac-sys__tip-btn" data-sys-tip-btn aria-expanded="false" aria-label="${escapeHTML(t('systemsTipLabel'))}">i</button>
        <span class="aac-sys__tip" data-sys-tip hidden>${escapeHTML(tip)}</span>
      </li>`;
    }

    function renderSystemsHtml() {
      const row = (state.eligibleRows && state.eligibleRows[0]) || (state.matches && state.matches[0]);
      const key = row ? recordLiveSheetKey(row) : null;
      const spec = key ? AAC_MODEL_SYSTEMS[key] : null;
      if (!spec) return '';
      const assist = AAC_ASSIST_IDS.filter((id) => spec[id] === 'yes' || spec[id] === 'autolearn');
      const extras = ['warnings', 'circuit'].filter((id) => spec[id] === 'yes');
      const count = assist.length + extras.length;
      if (!count) return '';
      const cols = window.matchMedia('(max-width: 767px)').matches ? 1 : 2;
      const lastCount = assist.length % cols === 0 ? cols : assist.length % cols;
      const lastStart = assist.length - lastCount;
      const assistItems = assist.map((id, i) => renderSystemItem(id, spec[id], i >= lastStart)).join('');
      const extraItems = extras.map((id) => renderSystemItem(id, spec[id], true)).join('');
      const extraBlock = extraItems
        ? `<p class="aac-sys__extra-label">${escapeHTML(t('systemsExtra'))}</p><ul class="aac-sys__list aac-sys__list--extra">${extraItems}</ul>`
        : '';
      const countLabel = String(t('systemsCount')).replace('{count}', String(count));
      return `<details class="aac-sys">
        <summary class="aac-sys__summary">
          <span class="aac-sys__summary-copy">
            <strong>${escapeHTML(t('systemsTitle'))}</strong>
            <span class="aac-sys__count">${escapeHTML(countLabel)}</span>
          </span>
          <svg class="aac-sys__chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </summary>
        <div class="aac-sys__body">
          <p class="aac-sys__intro">${escapeHTML(t('systemsIntro'))}</p>
          <ul class="aac-sys__list">${assistItems}</ul>
          ${extraBlock}
        </div>
      </details>`;
    }

    function completeStepPanel(panelName, completedSel, activeSel, value, valueSel) {
      const panel = $('[data-panel="' + panelName + '"]');
      const active = $(activeSel);
      const completed = $(completedSel);
      const valueEl = valueSel ? $(valueSel) : null;
      if (valueEl && value !== undefined) valueEl.textContent = value;
      active?.classList.add('hidden');
      completed?.classList.remove('hidden');
      panel?.classList.add('is-completed');
      completed?.querySelectorAll('[data-i18n]').forEach((el) => { el.textContent = t(el.dataset.i18n); });
    }

    function resetStepPanel(panelName, completedSel, activeSel) {
      const panel = $('[data-panel="' + panelName + '"]');
      panel?.classList.remove('is-completed');
      $(activeSel)?.classList.remove('hidden');
      $(completedSel)?.classList.add('hidden');
    }

    function completeCodePanel(code) {
      completeStepPanel('code', '[data-code-completed]', '[data-code-active]', code, '[data-code-value]');
    }

    function completeDatePanel(label) {
      completeStepPanel('date', '[data-date-completed]', '[data-date-active]', label, '[data-date-value]');
    }

    function completeDisplayPanel(label) {
      completeStepPanel('display', '[data-display-completed]', '[data-display-active]', label, '[data-display-value]');
    }

    function formatSelectedDate(date) {
      if (!date) return '';
      return `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    }

    function displayChoiceLabel(selection) {
      if (selection === '12.3') return t('display12');
      if (selection === '7') return t('display7');
      if (selection === 'other') return t('displayOther');
      return selection;
    }

    function resetAfterCode() {
      cancelScan();
      exitMissFlow();
      ['date', 'display', 'result', 'detected'].forEach((name) => $('[data-panel="' + name + '"]').classList.add('hidden'));
      $('[data-panel="code"]')?.classList.remove('hidden');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      resetStepPanel('code', '[data-code-completed]', '[data-code-active]');
      resetStepPanel('date', '[data-date-completed]', '[data-date-active]');
      resetStepPanel('display', '[data-display-completed]', '[data-display-active]');
      $('[data-details-grid]').innerHTML = '';
      $('[data-details-block]')?.classList.add('hidden');
      const visual = $('[data-vehicle-visual]');
      if (visual) { visual.innerHTML = ''; visual.classList.add('hidden'); }
      $('[data-display-choices]').innerHTML = '';
      setFeedback('[data-date-feedback]', '');
      setFeedback('[data-display-hint]', '');
      $('[data-reset-btn]')?.classList.add('hidden');
      state.matches = []; state.eligibleRows = []; state.selectedCode = null; state.selectedDate = null; state.selectedDisplay = null; state.lastResult = null; state.missedCode = null; state.notifySource = 'manual';
      setActiveStep('code');
    }

    function escapeHTML(value) {
      return String(value ?? '').replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[ch]));
    }

    function meaning(row, group, raw) {
      const source = (CHECKER_DATA.sourceFiles || [])[row._source] || {};
      const item = source.legend?.[group]?.[String(raw)];
      const text = item?.[currentLang];
      return text ? text : String(raw);
    }

    function parseISODate(iso) {
      if (!iso) return null;
      const [y, m] = String(iso).split('-').map(Number);
      if (!y || !m) return null;
      return new Date(y, m - 1, 1);
    }

    function formatMonthYear(iso) {
      const dt = parseISODate(iso);
      if (!dt) return t('noValue');
      return `${String(dt.getMonth() + 1).padStart(2, '0')}/${dt.getFullYear()}`;
    }

    function hasAnyValue(rows, key) {
      return rows.some((r) => r[key] !== undefined && r[key] !== null && String(r[key]).trim() !== '');
    }

    function detailCard(key, value) {
      return `<div class="aac-checker__detail"><small>${escapeHTML(t('details.' + key))}</small><strong>${escapeHTML(value || t('noValue'))}</strong></div>`;
    }

    function formatValue(row, key) {
      if (key === 'Year_From') return formatMonthYear(row._yearFrom);
      const raw = row[key];
      if (raw === undefined || raw === null || String(raw).trim() === '') return t('noValue');
      if (['Steering', 'Production', 'Body', 'Transmission', 'Destination', 'Roof', 'Trunk', 'Edition'].includes(key)) return meaning(row, key, raw);
      return String(raw);
    }

    function vehicleImageKeyFor(row) {
      return recordVehicleDetailKey(row);
    }

    function vehicleImageFor(row) {
      const detail = recordVehicleDetailKey(row);
      const sheet = recordLiveSheetKey(row);
      const aliases = {
        corolla_ts: ['corolla_kombi'],
        corolla: ['corolla_hatchback'],
        corolla_limousine: [],
        bz4x_touring: []
      };
      const keys = [detail].concat(aliases[detail] || []);
      keys.push(sheet, normalizeLiveSheetBlockKey(detail));
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key && vehicleImages[key]) return vehicleImages[key];
      }
      return null;
    }

    function renderVehicleVisual(row) {
      const el = $('[data-vehicle-visual]');
      if (!el) return;
      const image = vehicleImageFor(row);
      if (!image) {
        el.innerHTML = '';
        el.classList.add('hidden');
        return;
      }
      const alt = formatValue(row, 'Vehicle_Name');
      el.innerHTML = `<img src="${escapeHTML(image)}" alt="${escapeHTML(alt)}" loading="lazy" decoding="async">`;
      el.classList.remove('hidden');
    }

    function renderDetails(rows) {
      if (!rows.length) return;
      const row = rows[0];
      renderVehicleVisual(row);
      const keys = ['Full_Code', 'Vehicle_Name', 'Engine', 'Transmission', 'Edition', 'Production', 'Body', 'Steering', 'Roof', 'Trunk'];
      const used = new Set();
      const html = keys.map((key) => {
        if (used.has(key)) return '';
        if ((key === 'Roof' && !hasAnyValue(rows, 'Roof')) || (key === 'Trunk' && !hasAnyValue(rows, 'Trunk'))) return '';
        if (['Production', 'Body', 'Edition'].includes(key) && !hasAnyValue(rows, key)) return detailCard(key, t('noValue'));
        used.add(key);
        return detailCard(key, formatValue(row, key));
      }).join('');
      $('[data-details-grid]').innerHTML = html;
      $('[data-details-block]')?.classList.remove('hidden');
      $('[data-panel="detected"]')?.classList.remove('hidden');
    }

    function aggregateSupport(rows) {
      const statuses = rows.map((r) => String(r.Support || '').trim().toUpperCase());
      if (statuses.includes('YES')) return 'YES';
      if (statuses.includes('UNKNOWN')) return 'UNKNOWN';
      return 'NO';
    }

    function levenshtein(a, b) {
      const dp = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
      for (let i = 0; i <= a.length; i++) dp[i][0] = i;
      for (let j = 0; j <= b.length; j++) dp[0][j] = j;
      for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
          const cost = a[i - 1] === b[j - 1] ? 0 : 1;
          dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
        }
      }
      return dp[a.length][b.length];
    }

    function closestCodes(input, limit) {
      return Array.from(recordsByCode.keys()).map((code) => [code, levenshtein(input, code)])
        .sort((a, b) => a[1] - b[1]).slice(0, limit).map(([code]) => code);
    }

    function getDisplayValue(row) { return row.Display || row.Cluster || ''; }
    function normalizeDisplay(value) {
      const s = String(value || '').toLowerCase().replace(/,/g, '.').trim();
      if (s.includes('12.3') || s.includes('12,3')) return '12.3';
      if (s.includes('7')) return '7';
      return s || '';
    }
    function requiresDisplay(rows) { return rows.some((row) => normalizeDisplay(getDisplayValue(row))); }

    function minSupportedText(rows) {
      const dates = rows.map((r) => parseISODate(r._yearFrom)).filter(Boolean).sort((a, b) => a - b);
      if (!dates.length) return '';
      const d = dates[0];
      return `${t('supportedFrom')} ${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}.`;
    }

    function renderMonthYearOptions() {
      const month = $('[data-month-select]');
      const year = $('[data-year-select]');
      if (!month || !year) return;
      const currentMonth = month.value;
      const currentYear = year.value;
      month.setAttribute('aria-label', I18N[currentLang].months[0] || 'Month');
      year.setAttribute('aria-label', t('yearPlaceholder'));
      month.innerHTML = I18N[currentLang].months.map((name, idx) => `<option value="${idx || ''}">${name}</option>`).join('');
      const years = [];
      for (let y = 2020; y <= 2026; y++) years.push(y);
      year.innerHTML = [`<option value="">${t('yearPlaceholder')}</option>`, ...years.map((y) => `<option value="${y}">${y}</option>`)].join('');
      if (currentMonth) month.value = currentMonth;
      if (currentYear && years.includes(Number(currentYear))) year.value = currentYear;
    }

    function showResultView() {
      ['code', 'date', 'display'].forEach((name) => $('[data-panel="' + name + '"]').classList.add('hidden'));
      $('[data-panel="detected"]')?.classList.remove('hidden');
      $('[data-reset-btn]')?.classList.remove('hidden');
      $('.aac-checker__body')?.classList.add('is-result-only');
      const body = $('.aac-checker__body');
      if (body) body.scrollTop = 0;
    }

    function renderResult(status, reason) {
      showResultView();
      $('[data-panel="result"]').classList.remove('hidden');
      setActiveStep('result');
      const normalized = String(status || 'NO').toUpperCase();
      const reasonText = reason || '';
      state.lastResult = { status: normalized, reason: reasonText };
      const detailRows = state.eligibleRows.length ? state.eligibleRows : state.matches;
      renderDetails(detailRows);
      const cls = normalized === 'YES' ? 'yes' : normalized === 'UNKNOWN' ? 'unknown' : 'no';
      const title = normalized === 'YES' ? t('compatibleTitle') : normalized === 'UNKNOWN' ? t('unknownTitle') : t('notCompatibleTitle');
      const text = normalized === 'YES' ? '' : normalized === 'UNKNOWN' ? t('unknownText') : t('notCompatibleText');
      const icon = normalized === 'YES'
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>'
        : normalized === 'UNKNOWN'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 8v5M12 16h.01"/><circle cx="12" cy="12" r="9"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      $('[data-result-box]').innerHTML = `
        <div class="aac-checker__result aac-checker__result--${cls}">
          <div class="aac-checker__result-row">
            <span class="aac-checker__result-icon">${icon}</span>
            <div class="aac-checker__result-copy">
              <strong class="aac-checker__result-status">${escapeHTML(title)}</strong>
            </div>
          </div>
          ${text ? `<p class="aac-checker__result-text">${escapeHTML(text)}</p>` : ''}
          ${reasonText ? `<div class="aac-checker__result-reason">${escapeHTML(reasonText)}</div>` : ''}
        </div>
        ${normalized === 'YES' ? renderSystemsHtml() : ''}
        ${normalized === 'YES' && getCheckoutVariantId() ? `<div class="aac-checker__checkout"><button type="button" class="aac-checker__checkout-btn" data-checker-checkout><span class="aac-checker__checkout-label">${escapeHTML(t('orderNow'))}</span><span class="aac-checker__checkout-hint">${escapeHTML(t('orderHint'))}</span><span class="aac-checker__checkout-dots" aria-hidden="true"><span class="dot"></span><span class="dot"></span><span class="dot"></span></span></button></div>` : ''}
        <div class="aac-checker__request-note" data-request-note></div>`;
      bindCheckoutButton();
      bindSystemTips();
    }

    function rerenderLastResult() {
      if (state.lastResult) renderResult(state.lastResult.status, state.lastResult.reason);
    }

    function buildDemandPayload(resultStatus) {
      return {
        createdAt: new Date().toISOString(),
        language: currentLang,
        result: resultStatus,
        modelCode: state.selectedCode || normalizeCode($('[data-model-code]').value),
        vehicleDate: state.selectedDate ? `${state.selectedDate.getFullYear()}-${String(state.selectedDate.getMonth() + 1).padStart(2, '0')}` : null,
        instrumentCluster: state.selectedDisplay || null,
        vehicle: state.matches[0] ? {
          model: state.matches[0].Vehicle_Name || null,
          engine: state.matches[0].Engine || null,
          transmission: state.matches[0].Transmission ? meaning(state.matches[0], 'Transmission', state.matches[0].Transmission) : null,
          production: state.matches[0].Production ? meaning(state.matches[0], 'Production', state.matches[0].Production) : null,
          body: state.matches[0].Body ? meaning(state.matches[0], 'Body', state.matches[0].Body) : null,
          steering: state.matches[0].Steering ? meaning(state.matches[0], 'Steering', state.matches[0].Steering) : null
        } : null
      };
    }

    function saveDemandRequest(resultStatus) {
      const payload = buildDemandPayload(resultStatus);
      const note = $('[data-request-note]');
      try {
        const key = 'aacCheckerDemandRequests';
        const existing = JSON.parse(localStorage.getItem(key) || '[]');
        existing.push(payload);
        localStorage.setItem(key, JSON.stringify(existing));
        if (note) note.textContent = t('suggestionSaved');
        if (config.demandEndpoint) {
          fetch(config.demandEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => {});
        }
      } catch (e) {
        if (note) note.textContent = t('suggestionError');
      }
    }

    function renderDisplayStep(rows) {
      const options = Array.from(new Set(rows.map((r) => normalizeDisplay(getDisplayValue(r))).filter(Boolean)));
      const ordered = ['12.3', '7'].filter((x) => options.includes(x));
      const otherOptions = options.filter((x) => !ordered.includes(x));
      const finalOptions = [...ordered, ...otherOptions, 'other'];
      setFeedback('[data-display-hint]', t('displayHint'), '');
      $('[data-display-choices]').innerHTML = finalOptions.map((opt) => {
        let title = opt, sub = '';
        if (opt === '12.3') { title = t('display12'); sub = t('display12Sub'); }
        else if (opt === '7') { title = t('display7'); sub = t('display7Sub'); }
        else if (opt === 'other') { title = t('displayOther'); sub = t('displayOtherSub'); }
        return `<button type="button" class="aac-checker__choice" data-display="${escapeHTML(opt)}"><strong>${escapeHTML(title)}</strong><span>${escapeHTML(sub)}</span></button>`;
      }).join('');
      $$('[data-display-choices] [data-display]').forEach((btn) => btn.addEventListener('click', () => handleDisplayChoice(btn.dataset.display)));
    }

    function handleDisplayChoice(selection) {
      state.selectedDisplay = selection;
      completeDisplayPanel(displayChoiceLabel(selection));
      if (selection === 'other') { renderResult('NO', t('displayMismatch')); return; }
      const filtered = state.eligibleRows.filter((row) => normalizeDisplay(getDisplayValue(row)) === selection);
      if (!filtered.length) { renderResult('NO', t('displayMismatch')); return; }
      state.eligibleRows = filtered;
      renderResult(aggregateSupport(filtered), '');
    }

    function handleDateContinue() {
      const month = Number($('[data-month-select]').value);
      const year = Number($('[data-year-select]').value);
      if (!month || !year) { setFeedback('[data-date-feedback]', t('dateMissing'), 'error'); return; }
      const selected = new Date(year, month - 1, 1);
      state.selectedDate = selected;
      const eligible = state.matches.filter((row) => {
        const from = parseISODate(row._yearFrom);
        return !from || selected >= from;
      });
      if (!eligible.length) {
        state.eligibleRows = [];
        setFeedback('[data-date-feedback]', '', '');
        completeDatePanel(formatSelectedDate(selected));
        renderResult('NO', t('olderThanData') + ' ' + minSupportedText(state.matches));
        return;
      }
      state.eligibleRows = eligible;
      setFeedback('[data-date-feedback]', '', 'ok');
      completeDatePanel(formatSelectedDate(selected));
      if (requiresDisplay(eligible)) {
        renderDisplayStep(eligible);
        $('[data-panel="display"]').classList.remove('hidden');
        $('[data-panel="result"]').classList.add('hidden');
        setActiveStep('display');
      } else {
        renderResult(aggregateSupport(eligible), '');
      }
    }

    const MISS_PANELS = ['notfound', 'notify', 'notify-done'];
    const PENCIL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12.8 6.7 17.3 11.2"/><path d="M4 20l1-4.4L15.7 4.9a1.5 1.5 0 0 1 2.1 0l1.3 1.3a1.5 1.5 0 0 1 0 2.1L7.4 19.1 4 20Z"/></svg>';
    const REMOVE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

    function restoreCheckerHeader() {
      const headline = $('.aac-checker__headline');
      const intro = $('.aac-checker__intro');
      if (headline) headline.textContent = t('headline');
      if (intro) intro.textContent = t('intro');
    }

    function setCheckerHeader(titleKey, introKey) {
      const headline = $('.aac-checker__headline');
      const intro = $('.aac-checker__intro');
      if (headline) headline.textContent = t(titleKey);
      if (intro) intro.textContent = t(introKey);
    }

    function hideMissPanels() {
      MISS_PANELS.forEach((name) => $('[data-panel="' + name + '"]')?.classList.add('hidden'));
    }

    function showMissPanel(name) {
      ['code', 'date', 'display', 'result', 'detected'].concat(MISS_PANELS).forEach((panel) => {
        $('[data-panel="' + panel + '"]')?.classList.toggle('hidden', panel !== name);
      });
      $('[data-reset-btn]')?.classList.add('hidden');
      root.classList.add('is-miss-flow');
      $('.aac-checker__body')?.classList.add('is-result-only');
      const body = $('.aac-checker__body');
      if (body) body.scrollTop = 0;
    }

    function exitMissFlow() {
      hideMissPanels();
      root.classList.remove('is-miss-flow');
      $('.aac-checker__body')?.classList.remove('is-result-only');
      restoreCheckerHeader();
      setFeedback('[data-notify-feedback]', '');
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function notifyRowHtml(code, canRemove) {
      return `<div class="aac-checker__notify-row" data-notify-row>
        <input type="text" class="aac-checker__notify-input" data-notify-code value="${escapeHTML(code || '')}" ${code ? 'readonly' : ''} autocomplete="off" spellcheck="false">
        <button type="button" class="aac-checker__icon-btn" data-notify-edit aria-label="${escapeHTML(t('notifyEditCode'))}">${PENCIL_ICON}</button>
        ${canRemove ? `<button type="button" class="aac-checker__icon-btn" data-notify-remove aria-label="${escapeHTML(t('notifyRemoveCode'))}">${REMOVE_ICON}</button>` : ''}
      </div>`;
    }

    function renderNotifyCodes(codes) {
      const wrap = $('[data-notify-codes]');
      if (!wrap) return;
      const list = (codes || []).length ? codes : [''];
      wrap.innerHTML = list.map((code, idx) => notifyRowHtml(code, idx > 0)).join('');
    }

    function collectNotifyCodes() {
      return $$('[data-notify-code]').map((input) => normalizeCode(input.value)).filter(Boolean);
    }

    function setNotifyLang(lang) {
      const next = lang === 'en' ? 'en' : 'de';
      state.notifyLang = next;
      $$('[data-notify-lang]').forEach((btn) => btn.classList.toggle('is-active', btn.dataset.notifyLang === next));
    }

    function showNotFound(code, source) {
      const normalized = normalizeCode(code);
      state.missedCode = normalized;
      state.notifySource = source === 'photo' ? 'photo' : 'manual';
      const input = $('[data-model-code]');
      if (input) {
        input.value = normalized;
        input.classList.remove('is-invalid');
      }
      setFeedback('[data-feedback]', '', '');
      const codeEl = $('[data-notfound-code]');
      if (codeEl) codeEl.textContent = normalized;
      const suggestions = closestCodes(normalized, 4);
      const box = $('[data-notfound-suggestions]');
      if (box) {
        if (suggestions.length) {
          box.innerHTML = `<strong>${escapeHTML(t('suggestions'))}</strong>${suggestions.map((entry) => `<button type="button" data-code="${escapeHTML(entry)}">${escapeHTML(entry)}</button>`).join('')}`;
        } else {
          box.innerHTML = '';
        }
      }
      setCheckerHeader('notFoundTitle', 'notFoundIntro');
      showMissPanel('notfound');
    }

    function retryMissedCode() {
      const code = state.missedCode || '';
      exitMissFlow();
      $('[data-panel="code"]')?.classList.remove('hidden');
      resetStepPanel('code', '[data-code-completed]', '[data-code-active]');
      setActiveStep('code');
      const input = $('[data-model-code]');
      if (input) {
        input.value = code;
        input.focus();
      }
    }

    function openNotifyForm() {
      const email = $('[data-notify-email]');
      if (email) email.value = '';
      setNotifyLang(currentLang);
      renderNotifyCodes([state.missedCode || normalizeCode($('[data-model-code]')?.value)]);
      setFeedback('[data-notify-feedback]', '');
      setCheckerHeader('notifyTitle', 'notifyIntro');
      showMissPanel('notify');
      email?.focus();
    }

    function normalizeNotifyUrl(url) {
      return String(url || '')
        .trim()
        .replace(/^https:\/\/script\.google\.com\/a\/macros\/[^/]+\/s\//i, 'https://script.google.com/macros/s/');
    }

    function notifySaved(data) {
      return !!(data && data.ok === true && Number(data.rows) > 0 && data.ping !== true);
    }

    async function readNotifyResponse(res) {
      if (!res || res.type === 'opaque' || !res.ok) return null;
      return res.json().catch(() => null);
    }

    async function postNotifyPayload(payload) {
      const url = normalizeNotifyUrl(config.notifyUrl);
      if (!url) throw new Error('no-endpoint');
      const body = JSON.stringify(payload);

      try {
        const res = await fetch(url, {
          method: 'POST',
          redirect: 'follow',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body
        });
        if (notifySaved(await readNotifyResponse(res))) return true;
      } catch (e) {}

      const joiner = url.indexOf('?') >= 0 ? '&' : '?';
      const res = await fetch(url + joiner + 'payload=' + encodeURIComponent(body), {
        cache: 'no-store',
        redirect: 'follow'
      });
      if (notifySaved(await readNotifyResponse(res))) return true;
      throw new Error('rejected');
    }

    async function handleNotifySubmit() {
      const btn = $('[data-notify-submit]');
      const email = String($('[data-notify-email]')?.value || '').trim();
      const codes = collectNotifyCodes();
      const invalidCode = codes.find((code) => !validateModelCode(code).ok);
      if (!isValidEmail(email)) {
        setFeedback('[data-notify-feedback]', t('notifyEmailInvalid'), 'error');
        $('[data-notify-email]')?.focus();
        return;
      }
      if (!codes.length || invalidCode) {
        setFeedback('[data-notify-feedback]', t('notifyCodeInvalid'), 'error');
        return;
      }
      setFeedback('[data-notify-feedback]', '', '');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-loading');
      }
      const payload = {
        createdAt: new Date().toISOString(),
        email,
        language: state.notifyLang || currentLang,
        shopLang: currentLang,
        source: state.notifySource || 'manual',
        codes,
        requestId: 'req_' + Date.now().toString(36)
      };
      try {
        await postNotifyPayload(payload);
        setCheckerHeader('notifySuccessTitle', 'notifySuccessText');
        showMissPanel('notify-done');
      } catch (e) {
        setFeedback('[data-notify-feedback]', t('suggestionError'), 'error');
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      }
    }

    function handleCheck() {
      resetAfterCode();
      const input = $('[data-model-code]');
      const validation = validateModelCode(input.value);
      input.value = normalizeCode(input.value);
      input.classList.toggle('is-invalid', !validation.ok);
      if (!validation.ok) { setFeedback('[data-feedback]', validation.message, 'error'); return; }
      const matches = recordsByCode.get(validation.code) || [];
      if (!matches.length) {
        showNotFound(validation.code, 'manual');
        return;
      }
      setFeedback('[data-feedback]', '', '');
      input.classList.remove('is-invalid');
      state.matches = matches;
      state.selectedCode = validation.code;
      completeCodePanel(validation.code);
      setFeedback('[data-feedback]', '', '');
      if (aggregateSupport(matches) === 'NO') {
        renderDetails(matches);
        renderResult('NO', '');
        return;
      }
      renderDetails(matches);
      $('[data-panel="date"]').classList.remove('hidden');
      setActiveStep('date');
    }

    function getHelp() {
      return document.querySelector('[data-aac-help]');
    }

    function mountHelp() {
      const help = getHelp();
      if (!help || help.dataset.mounted === 'true') return;
      if (!help.__aacHome) {
        help.__aacHome = { parent: help.parentNode, next: help.nextSibling };
      }
      document.body.appendChild(help);
      help.dataset.mounted = 'true';
    }

    function unmountHelp() {
      const help = getHelp();
      if (!help || !help.__aacHome || help.dataset.mounted !== 'true') return;
      const home = help.__aacHome;
      if (home.next) home.parent.insertBefore(help, home.next);
      else home.parent.appendChild(help);
      help.dataset.mounted = 'false';
    }

    function getModelCodeHelpImages() {
      const script = root.querySelector('[data-checker-model-help-images]');
      if (script) {
        try {
          const parsed = JSON.parse(script.textContent || '[]').filter(Boolean);
          if (parsed.length) return parsed;
        } catch (e) {}
      }
      return [
        root.getAttribute('data-checker-model-image') || config.modelCodeImage || '',
        root.getAttribute('data-checker-model-image-2') || config.modelCodeImage2 || '',
        root.getAttribute('data-checker-model-image-3') || config.modelCodeImage3 || ''
      ].filter(Boolean);
    }

    function renderModelCodeHelpImages() {
      const imgs = getModelCodeHelpImages();
      if (!imgs.length) return '';
      const alt = escapeHTML(t('modelCodeModalTitle'));
      if (imgs.length === 1) {
        return `<img src="${escapeHTML(imgs[0])}" alt="${alt}">`;
      }
      const countClass = imgs.length >= 3 ? ' aac-checker__model-code-images--3' : '';
      return `<div class="aac-checker__model-code-images${countClass}">${imgs.map((src, index) => `<img src="${escapeHTML(src)}" alt="${alt} ${index + 1}">`).join('')}</div>`;
    }

    function getDisplayHelpImageSrc(key) {
      const displayImagesScript = root.querySelector('[data-checker-display-images]');
      if (displayImagesScript) {
        try {
          const parsed = JSON.parse(displayImagesScript.textContent || '{}');
          if (parsed?.[key]) return parsed[key];
        } catch (e) {}
      }
      return root.getAttribute(`data-checker-display-${key}`)
        || (key === '12' ? config.displayImage123 : key === '7' ? config.displayImage7 : config.displayImage42)
        || '';
    }

    function getDisplayHelpImages() {
      return [
        { src: getDisplayHelpImageSrc('12'), title: t('displayModalExample12'), sub: t('displayModalExample12Sub') },
        { src: getDisplayHelpImageSrc('7'), title: t('displayModalExample7'), sub: t('displayModalExample7Sub') },
        { src: getDisplayHelpImageSrc('42'), title: t('displayModalExample42'), sub: t('displayModalExample42Sub') }
      ].filter((x) => x.src);
    }

    function openHelp(type) {
      const help = getHelp();
      if (!help) return;
      const isDisplay = type === 'display';
      help.querySelector('[data-help-title]').textContent = isDisplay ? t('displayModalTitle') : t('modelCodeModalTitle');
      help.querySelector('[data-help-text]').textContent = isDisplay ? t('displayModalText') : t('modelCodeModalText');
      const visual = help.querySelector('[data-help-visual]');
      const displayImgs = isDisplay ? getDisplayHelpImages() : [];
      if (isDisplay) {
        visual.innerHTML = displayImgs.length
          ? `<div class="aac-checker__display-examples">${displayImgs.map((img) => `<div class="aac-checker__display-example"><img src="${escapeHTML(img.src)}" alt="${escapeHTML(img.title)}"><strong>${escapeHTML(img.title)}</strong><span>${escapeHTML(img.sub)}</span></div>`).join('')}</div>`
          : '';
      } else {
        visual.innerHTML = renderModelCodeHelpImages();
      }
      const helpCard = help.querySelector('.aac-checker__help-card');
      const visualCount = isDisplay ? displayImgs.length : getModelCodeHelpImages().length;
      helpCard?.classList.toggle('aac-checker__help-card--wide', visualCount >= 3);
      mountHelp();
      help.hidden = false;
      document.body.classList.add('aac-checker-help-open');
      help.scrollTop = 0;
      help.querySelector('[data-help-close]')?.focus();
    }

    function closeHelp() {
      const help = getHelp();
      if (help) help.hidden = true;
      document.body.classList.remove('aac-checker-help-open');
      unmountHelp();
    }

    function bindEvents() {
      $('[data-check-btn]')?.addEventListener('click', handleCheck);
      $('[data-model-code]')?.addEventListener('keydown', (e) => { if (e.key === 'Enter') handleCheck(); });
      $('[data-model-code]')?.addEventListener('input', () => {
        clearScanFeedbackTimer();
        $('[data-model-code]').classList.remove('is-invalid');
        setFeedback('[data-feedback]', '');
      });
      $('[data-date-btn]')?.addEventListener('click', handleDateContinue);
      $('[data-reset-btn]')?.addEventListener('click', () => {
        $('[data-model-code]').value = '';
        setFeedback('[data-feedback]', '');
        setScanPreview(null);
        resetAfterCode();
        $('[data-model-code]').focus();
      });
      $('[data-notfound-retry]')?.addEventListener('click', retryMissedCode);
      $('[data-notfound-notify]')?.addEventListener('click', openNotifyForm);
      $('[data-notify-add]')?.addEventListener('click', () => {
        const wrap = $('[data-notify-codes]');
        if (!wrap) return;
        wrap.insertAdjacentHTML('beforeend', notifyRowHtml('', true));
        wrap.querySelector('[data-notify-row]:last-child [data-notify-code]')?.focus();
      });
      $('[data-notify-codes]')?.addEventListener('click', (e) => {
        const edit = e.target.closest('[data-notify-edit]');
        const remove = e.target.closest('[data-notify-remove]');
        if (edit) {
          const input = edit.closest('[data-notify-row]')?.querySelector('[data-notify-code]');
          if (!input) return;
          input.removeAttribute('readonly');
          input.focus();
          input.select();
        }
        if (remove) {
          const rows = $$('[data-notify-row]');
          if (rows.length < 2) return;
          remove.closest('[data-notify-row]')?.remove();
        }
      });
      $$('[data-notify-lang]').forEach((btn) => {
        btn.addEventListener('click', () => setNotifyLang(btn.dataset.notifyLang));
      });
      $('[data-notify-submit]')?.addEventListener('click', handleNotifySubmit);
      $('[data-notify-again]')?.addEventListener('click', () => {
        $('[data-model-code]').value = '';
        setFeedback('[data-feedback]', '');
        setScanPreview(null);
        resetAfterCode();
        $('[data-model-code]').focus();
      });
      $('[data-notfound-suggestions]')?.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-code]');
        if (!btn) return;
        const input = $('[data-model-code]');
        if (input) input.value = btn.dataset.code;
        handleCheck();
      });
      $('[data-notify-email]')?.addEventListener('keydown', (e) => { if (e.key === 'Enter') handleNotifySubmit(); });
      $('[data-open-model-help]')?.addEventListener('click', () => openHelp('modelCode'));
      $('[data-open-display-help]')?.addEventListener('click', () => openHelp('display'));
      $('[data-help-close]')?.addEventListener('click', closeHelp);
      $('[data-aac-help]')?.addEventListener('click', (e) => { if (e.target === e.currentTarget) closeHelp(); });
      /* Android oeffnet ein input[accept=image/*] direkt in der Galerie (ohne
         Kamera-Option wie iOS). Deshalb dort eine eigene Auswahl anzeigen:
         "Foto aufnehmen" (capture-Input) oder "Aus Galerie waehlen". */
      const isAndroid = /android/i.test(navigator.userAgent || '');
      const scanChoice = $('[data-scan-choice]');
      const hideScanChoice = () => {
        if (!scanChoice) return;
        scanChoice.classList.add('hidden');
        scanChoice.setAttribute('hidden', '');
      };
      const showScanChoice = () => {
        if (!scanChoice) return;
        scanChoice.classList.remove('hidden');
        scanChoice.removeAttribute('hidden');
      };
      $('[data-scan-upload]')?.addEventListener('click', () => {
        if (isAndroid && scanChoice) {
          if (scanChoice.classList.contains('hidden')) showScanChoice();
          else hideScanChoice();
        } else {
          openScanPicker($('[data-scan-file]'));
        }
      });
      $('[data-scan-choice-camera]')?.addEventListener('click', () => {
        hideScanChoice();
        openScanPicker($('[data-scan-camera-file]'));
      });
      $('[data-scan-choice-gallery]')?.addEventListener('click', () => {
        hideScanChoice();
        openScanPicker($('[data-scan-file]'));
      });
      document.addEventListener('click', (e) => {
        if (!scanChoice || scanChoice.classList.contains('hidden')) return;
        if (e.target.closest('[data-scan-choice]') || e.target.closest('[data-scan-upload]')) return;
        hideScanChoice();
      });
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-sys-tip-btn]') || e.target.closest('[data-sys-tip]')) return;
        closeSystemTips();
      });
      $('[data-scan-camera]')?.addEventListener('click', () => openScanPicker($('[data-scan-camera-file]')));
      $('[data-scan-file]')?.addEventListener('change', handleScanInputChange);
      $('[data-scan-camera-file]')?.addEventListener('change', handleScanInputChange);
      $('[data-scan-reupload]')?.addEventListener('click', handleScanReupload);
      $$('[data-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled || !btn.classList.contains('is-clickable')) return;
          navigateToStep(btn.dataset.step);
        });
      });
    }

    return {
      init: async function () {
        root.classList.add('is-loading');
        try {
          await fetchCheckerData();
          renderI18n();
          bindEvents();
          updateStepperNav();
          root.classList.remove('is-loading', 'is-booting');
          root.classList.add('is-ready');
        } catch (e) {
          root.classList.remove('is-loading', 'is-booting');
          root.classList.add('is-error');
          setFeedback('[data-feedback]', config.loadError || 'Compatibility data unavailable.', 'error');
        }
      },
      reset: resetAfterCode,
      prewarmScan: function () {},
      cancelScan: cancelScan,
      closeHelp: closeHelp
    };
  }

  window.AacModelChecker = {
    init: function (root, config) {
      if (!root || root.__aacChecker) return root.__aacChecker;
      const instance = createChecker(root, config || {});
      root.__aacChecker = instance;
      return instance;
    }
  };

})();
